import * as React from 'react';
import { useEffect } from 'react'
import { model, TerminalCommunicationService } from '@fresche/terminal-lib';
import { FContinueButton, FNumericInput, FSelectInput, FTextInput, FLabel, FDateTimeInput, FMultilineInput, FGrid } from '@fresche/ui-lib-react';
import { ToastContainer, toast } from 'react-toastify';
import { MegaMenu } from 'primereact/megamenu';
import { Tooltip } from 'primereact/tooltip';
import TextDisplay from '../layout/text-display/text-display';
import 'react-toastify/dist/ReactToastify.css';
import './base.css';
import OptumGrid from "../layout/ui/OptumGrid";
import CustomBase from "./custom-base";
import {Button} from "primereact/button";
import { MultiSelect } from 'primereact/multiselect';
import { getTenantIds } from "../components/programs/TenantList";
import { portunusAbilities } from "../security/AuthProxy";
import SnapshotBase from './SnapshotBase';
import * as AuthProxy from "../security/AuthProxy";

declare global {
  interface Window { config: any; }
}

export interface BaseProps {
  type?: string;
  formData: any;
  screenDef: any;
  isActiveScreen: boolean;
}

/**
 *
 */
class BaseComponent<P = {}, S = any> extends CustomBase { 

  protected terminal = new TerminalCommunicationService();
  private isSubmitting = false; // Prevent duplicate submissions

  public inputErrors: any;

  public dateFormat: string;
  public timeSeparator: string;
  public showSeconds = true;
  public funKeyPos: string;
  public legacyMode: boolean;
  public exported = false;
  public conditions: any = {};

  public functionKeys: any;
  public formatedInputs: any[];
  public selectedActionField = 'selected';

  protected focusedField = '';
  protected focusedFieldId = '';
  protected tablerowFocusedField = -1; // 0 = input, >0 = datarow

  protected dataGrid: React.RefObject<FGrid> = React.createRef();
  public keysNavigation = React.createRef();
  protected screenDef: any;
  protected formData: any;
  private isProtected = false;
  private tenants = [];

  public menu: MegaMenu; // = React.createRef();

  /**
   *
   */
  constructor(props: BaseProps) {
    super(props);

    this.dateFormat = window.config['ui'] ? window.config['ui']['dateFormat'] : 'yyyy-mm-dd';
    this.timeSeparator = window.config['ui'] ? window.config['ui']['timeSeparator'] : ':';
    this.showSeconds = window.config['ui'] ? window.config['ui']['showSeconds'] : true;
    this.funKeyPos = window.config['ui'] ? window.config['ui']['funKeyPos'] : 'top';

    this.handleKeyboardEvents = this.handleKeyboardEvents.bind(this);
    this.initErrorMessages = this.initErrorMessages.bind(this);
    this.tableAction = this.tableAction.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.isValid = this.isValid.bind(this);

    this.screenDef = this.props.screenDef;
    this.formData = this.props.formData;

    // Split inputs by rows
    this.formatedInputs = [];
    this.formatedInputs = this.formatInputs(props.screenDef);

    this.inputErrors = {};
    this.state = {
      roles : [],
      showMultiEnvSearch: false,
      disableSaveButton: false
    };
    this.initErrorMessages(this.props);
    this.setConditions(this.props);
    this.setDefaultCursor();

    this.functionKeys = [];
    if (props.screenDef.functionKeys && props.screenDef.functionKeys.length) {
      this.functionKeys = this.formatFunctionKeys();
    }
  }
  componentWillMount(): void {
    if(process.env.REACT_APP_API_ENV == 'local') {
      this.setState({showMultiEnvSearch: true});
    } else {
        const tenant = this.formData.currentTenant;
        console.log('componentWillMount portunusAbilities');
        portunusAbilities(tenant)
        .then((res: any) =>
          res.json())
        .then((data) => {
          console.log('portunusAbilities =', data);
          const roles = data['abilities']['all-abilities'];
          this.setState({roles: roles});
          for(const role in this.state.roles) {
            if(this.state.roles[role].includes("multienv.access.grant")) {
              this.setState({showMultiEnvSearch: true});
              return this.tenants;
            }
          }
        });
    }
  }

  /**
  /**
   *
   */
  componentWillUnmount(): void {
    document.removeEventListener('keydown', this.handleKeyboardEvents, false);
  }

  /**
   *
   */
  componentDidUpdate(): void {
    super.componentDidUpdate();

    // Reset submission flag when new screen data arrives
    this.isSubmitting = false;

    // When we pass from a popup to a view
    if (JSON.stringify(this.screenDef) !== JSON.stringify(this.props.screenDef)) {
      this.formatedInputs = [];
      if (this.props.screenDef.inputs && this.props.screenDef.inputs.length) {
        this.formatedInputs = this.formatInputs(this.props.screenDef);
      }

      this.setDefaultCursor();
      this.initErrorMessages(this.props);
      this.formData = this.props.formData;
      this.screenDef = this.props.screenDef;
      this.setConditions(this.props);

      this.functionKeys = [];
      if (this.props.screenDef.functionKeys && this.props.screenDef.functionKeys.length) {
        this.functionKeys = this.formatFunctionKeys();
      }

      this.forceUpdate();
    } else {
      let needRefreshState = false;
      let needRefreshForError = false;

      if (this.formData.cursorField !== this.props.formData.cursorField) {
        this.formData.cursorField = this.props.formData.cursorField;
        this.setDefaultCursor();
      }

      if (this.formData.cursorTableRow !== this.props.formData.cursorTableRow) {
        this.formData.cursorTableRow = this.props.formData.cursorTableRow;
        this.setDefaultCursor();
      }

      // Because we have a dynamic nested object, we compare each node value
      if (JSON.stringify(this.formData.fields) !== JSON.stringify(this.props.formData.fields)) {
        needRefreshState = true;
      }

      if (JSON.stringify(this.formData['messageDTO']) !== JSON.stringify(this.props.formData['messageDTO'])) {
        needRefreshForError = true;
        needRefreshState = true;
      }

      if (JSON.stringify(this.formData.portunusVerb) !== JSON.stringify(this.props.formData.portunusVerb)) {
        needRefreshState = true;
      }

      if (this.formData['programMode'] !== this.props.formData['programMode']) {
        needRefreshState = true;
      }

      if (this.formData.subfile && this.props.formData.subfile) {
        for (let index = 0; index < this.props.formData.subfile.length; index++) {
          const propsFields = JSON.stringify(this.props.formData.subfile[index]);
          const stateFields = this.formData.subfile[index] ? JSON.stringify(this.formData.subfile[index]) : '';

          const propsErrors = JSON.stringify(this.props.formData.subfile[index].messageDTO);
          const stateError = this.formData.subfile[index] ? JSON.stringify(this.formData.subfile[index].messageDTO) : '';

          if (propsFields !== stateFields) {
            needRefreshState = true;
          }

          if (propsErrors !== stateError) {
            needRefreshForError = true;
          }
        }

        if (this.formData.subfile.length !== this.props.formData.subfile.length) {
          needRefreshState = true;
        }
      }

      if (this.formData.subfileHasAllData !== this.props.formData.subfileHasAllData) {
        needRefreshState = true;
      }

      if (this.props.formData.subfileHasAllData) {
        if (this.formData.subfileTopRRN !== this.props.formData.subfileTopRRN) {
          needRefreshState = true;
        }
      }

      if (this.formData.subfilePageNumber !== this.props.formData.subfilePageNumber) {
        needRefreshState = true;
      }

      if (needRefreshForError) {
        this.initErrorMessages(this.props);
      }

      if (needRefreshState) {
        this.formData = this.props.formData;
        this.setConditions(this.props);
        this.forceUpdate();
      }
    }
    // call a function onLoad to replace TASKnnnnnn as alink
    if (this.screenDef.onLoad && (this as any)[this.screenDef.onLoad]) {
      (this as any)[this.screenDef.onLoad]();
    }
    if (this.props.formData.gridExport && !this.exported) {
      if(this.props.formData.exportSubFileList.length === 0) {
        return;
      } else {
        this.exported = true;
        this.formData.gridExport = false;
      }
      setTimeout(this.downloadCSV, 1000, this);
    }

  }

  /**
   *
   */
  componentDidMount(): void {
    super.componentDidUpdate();

    document.addEventListener('keydown', this.handleKeyboardEvents, false);
    this.setDefaultCursor();
    if(process.env.REACT_APP_API_ENV != 'local') {
      console.log('componentDidMount');
      getTenantIds().then((res: any) =>
        res.json()).then((data) => {
        console.log('getTenantIds=', data);
          if (data && data.roles && data.roles.length > 0) {
            let tenant = "";
            for(let i=0; i<data.roles.length; i++) {
              tenant = data.roles[i];
              this.tenants.push({value: tenant, label: tenant});
            }
          }
        })
    }
    // call a function onLoad to replace TASKnnnnnn as alink
    if (this.screenDef.onLoad && (this as any)[this.screenDef.onLoad]) {
      (this as any)[this.screenDef.onLoad]();
    }
  }

  /**
   *
   */
  setDefaultCursor(): void {
    setTimeout((): void => {
      let selectors = [
        'input:not([disabled]):not([readonly]):not([tabindex="-1"])',
        'select:not([disabled]):not([readonly]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([readonly]):not([tabindex="-1"])'
      ];

      // If we have a default field in the payload
      if (this.formData && this.formData.cursorField) {
        selectors = [
          `#${this.formData.cursorField}`
        ];
      }

      let rootToSearch: any = document;

      // if we are in a popup dialog then we need to search inside this dialog (not in all DOM)
      if (this.props.type === 'popup') {
        rootToSearch = document.querySelector('div.p-dialog');
      }

      let focusFieldFound = false;

      // If we have a default field in the payload
      if (this.formData && this.formData.cursorField) {
        const cursorField = '#' + this.formData.cursorField.split('.').join('\\.');

        const focusable = rootToSearch.querySelectorAll(cursorField);

        if (focusable.length > 0) {
          const toFocus: any = focusable[0];
          toFocus.focus();
          focusFieldFound = true;
        }
      }

      if (focusFieldFound === false) {
        const selectors = [
          'input:not([disabled]):not([readonly]):not([tabindex="-1"])',
          'select:not([disabled]):not([readonly]):not([tabindex="-1"])',
          'textarea:not([disabled]):not([readonly]):not([tabindex="-1"])',
          '.p-checkbox-box:not([disabled]):not([readonly]):not([tabindex="-1"])'
        ];
        const focusables = rootToSearch.querySelectorAll(selectors.join(','));

        if (focusables.length > 0) {
          let toFocus: any = focusables[0];

          // Check if the control is the SELECT ALL in the grid
          let currentParent = toFocus.parentNode;
          let isSelectAllCheckBox = false;

          while (currentParent !== null && !isSelectAllCheckBox) {
            if (currentParent.className && currentParent.className.indexOf('p-selection-column') > -1 && currentParent.attributes['role'].value !== 'cell') {
              isSelectAllCheckBox = true;
            }
            currentParent = currentParent.parentNode;
          }

          if (isSelectAllCheckBox) {
            if (focusables.length > 1) {
              toFocus = focusables[1];
            }
          }
          toFocus.focus();
        }
      }
    }, 1);
  }

  isVisible(el: any) {
    return (el && el.offsetParent !== null);
  }

  generateDynamicTitle(programMode:any, screenDef:any){
    if(programMode==="ADD"){
      return screenDef.addProgramTitle;
    }else if(programMode==="CHG"){
      return screenDef.editProgramTitle;
    }else if(programMode==="DSP"){
      return screenDef.title
    }
     return screenDef.title
  }
  generateDynamicProgName(programMode:any, screenDef:any){
    if(programMode==="ADD"){
      return screenDef.addProgramName;
    }else if(programMode==="CHG"){
      return screenDef.editProgramName;
    }else if(programMode==="DSP"){
      return screenDef.programName
    }
       return screenDef.programName
  }

  /**
   * @param val Value can be anything (string, numeric, datetime)
   * @param zeroNotAllow if zero value not want consider as valid value then pass as true flag 
   * otherwise by default zero value is not consider as empty value
   * @returns true if the value is not set
   */
  isEmpty(val: any, zeroNotAllow = false): boolean {
    return !!(val === undefined || val === null || val.length <= 0 || (typeof val === 'number' && isNaN(val)) || (zeroNotAllow && val == 0) || val === '0001-01-01');
  }

  /**
   * @param field Field ID to check
   * @returns true if the component has an error
   */
  componentIsInError(field: string): boolean {
    const el = document.getElementById(field);

    // Base on current Fresche component structure we must find the parent of the parent then check if the next component is an error-msg
    if (el && el.parentElement && el.parentElement.parentElement) {
      const nextSiblingComponent = el.parentElement.parentElement.nextElementSibling;

      if (nextSiblingComponent && nextSiblingComponent.className.indexOf('error-msg') >= 0) {
        return this.isVisible(nextSiblingComponent);
      }
    }

    return false;
  }

  /**
  * Checks if all the required visible fields are filled
  */
  isValid() {
    this.inputErrors = {};
    let isFirstElementInError = true;
    let valid = true;

    // Loop on all REQUIRED field
    if (this.screenDef && this.screenDef.inputs) {
      this.screenDef.inputs.forEach((input: any) => {
        if (input.isLabel === false) {
          if (input.required && this.isVisible(document.getElementById(input.field))) {
            if (this.isEmpty(this.formData.fields[input.field], input['zeroNotAllow'])) {
              valid = false;
              this.inputErrors[input.field] = (input.requiredMessage === undefined || input.requiredMessage === '')
                               ?'Value required.':input.requiredMessage;
              if (isFirstElementInError) {
                isFirstElementInError = false;
                document.getElementById(input.field).focus();
              }
            }
          }
        }
      });
    }
    return valid;
  }

  /**
   * initialize the view
   */
  initErrorMessages(props: any): void {
    if (props.formData['messageDTO']) {
      this.handleMessages(props.formData['messageDTO']);
      // Flush messageDTO because its displayed to the user
      props.formData['messageDTO'] = [];
    }

    // validates grid field conditions
    if (props.formData['subfile'] && props.formData['subfile'].length > 0) {
      for (let i = 0; i < props.formData['subfile'].length; i++) {
        const rowData = props.formData['subfile'][i];
        if (rowData['messageDTO']) {
          this.onGridError(rowData['messageDTO']);
          // Flush messageDTO because its displayed to the user
          rowData['messageDTO'] = [];
        }
      }
    }
  }

  /**
   * Handles Keyboard Events
   */
  handleKeyboardEvents(event: KeyboardEvent): void {
    // Replace KEYCODE_TO_FUNCTION_KEY of common lib (typescript compatibility)
    const KEYCODE_TO_FUNCTION_KEY = new Map<string, string>([
      ['F1-shift', 'F13'], ['F2-shift', 'F14'], ['F3-shift', 'F15'], ['F4-shift', 'F16'], ['F5-shift', 'F17'], ['F6-shift', 'F18'],
      ['F7-shift', 'F19'], ['F8-shift', 'F20'], ['F9-shift', 'F21'], ['F10-shift', 'F22'], ['F11-shift', 'F23'], ['F12-shift', 'F24'],
      ['F1-ctrl', 'F25'], ['F2-ctrl', 'F26'], ['F3-ctrl', 'F27'], ['F4-ctrl', 'F28'], ['F5-ctrl', 'F29'], ['F6-ctrl', 'F30'],
      ['F7-ctrl', 'F31'], ['F8-ctrl', 'F32'], ['F9-ctrl', 'F33'], ['F10-ctrl', 'F34'], ['F11-ctrl', 'F35'], ['F12-ctrl', 'F36']
    ]);

    if (this.props && this.screenDef && this.props.isActiveScreen) {
      
      if(event.key === "Enter" && !this.isValid()){
        event.preventDefault();
        event.stopPropagation();
      }
      // Handles function keys
      if (this.screenDef.functionKeys) {
        let keyCode = event.key;

        if (event.shiftKey) {
          keyCode = KEYCODE_TO_FUNCTION_KEY.get(event.key + '-shift');
        } else if (event.ctrlKey) {
          keyCode = KEYCODE_TO_FUNCTION_KEY.get(event.key + '-ctrl');
        }

        // If key is defined in the screen def
        const key = this.screenDef.functionKeys.filter((x: any): any => x.key === keyCode)[0];

        // F4 is always active by default in Synon system with X2E3 BUT in RPG program if F4 is not declared then the call should never be done
        const autoHandlingF4 = window.config['ui']['autoHandlingF4'];

        if (key !== undefined) {
          // Key is found in the screen def so take its command to call the backend
          event.preventDefault();
          this.defaultAction(key.command);
        } else if (keyCode === 'F4' && autoHandlingF4) {
          event.preventDefault();
          this.defaultAction('04');
        } else if (keyCode === 'F12') {
          event.preventDefault();
        } else if (['F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'].includes(event.key)) {
          event.preventDefault();
        }
      }

      // Handles multipage
      switch (event.key) {
        case 'PageUp':
          const PreviousKey = window.config['keys'] ? window.config['keys']['Previous'] : '28';

          event.preventDefault();
          event.stopPropagation();

          if (this.screenDef.isMultiPage) {
            event.preventDefault();
            event.stopPropagation();
            this.pageChanged({ direction: 'previous' });
          } else if (this.screenDef.gridDefinition) {
            this.dataGrid.current.movePage('previous');
          } else if (this.screenDef.functionKeys.find((k: any): any => k.command === PreviousKey) !== undefined) {
            event.preventDefault();
            event.stopPropagation();
            this.defaultAction(PreviousKey);
          }
          break;
        case 'PageDown':
          const NextKey = window.config['keys'] ? window.config['keys']['Next'] : '27';

          event.preventDefault();
          event.stopPropagation();

          if (this.screenDef.isMultiPage) {
            this.pageChanged({ direction: 'next' });
          } else if (this.screenDef.gridDefinition) {
            this.dataGrid.current.movePage('next');
          } else if (this.screenDef.functionKeys.find((k: any): any => k.command === NextKey) !== undefined) {
            event.preventDefault();
            event.stopPropagation();
            this.defaultAction(NextKey);
          }
          break;
        default:
          break;
      }
    }
  }

  /**
   * Message handler - generate msg for each one contained in the DTO
   */
  handleMessages(msgs: any): void {
    this.inputErrors = {};
    msgs.forEach((e: any): void => {
      // map every error message to a given field name
      if (e.fieldsName && e.fieldsName.length > 0) {
        e.fieldsName.forEach((field: any): void => {
          if (Object.keys(this.props.formData.fields).indexOf(field) > -1) {
            this.inputErrors[field] = e.messageText;
          }
        });
      } else {
        const msg: any = {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onClose: () => { this.setState({disableSaveButton: false})},
          onOpen: () => { this.setState({disableSaveButton: true}) }
        };
        switch (e.messageType) {
          case 'SNDERRMSG':
            toast.error(e.messageText, msg);
            break;
          case 'SNDINFMSG':
          case 'SNDSTSMSG':
            toast.info(e.messageText, msg);
            break;
          case 'SNDCMPMSG':
            toast.success(e.messageText, msg);
            break;
          default:
            toast.info(e.messageText, msg);
            break;
        }
      }
    });
  }

  // ================================================================
  //  CONDITIONS
  // ================================================================

  /**
   * Sets the conditions object for the current screen.
   */
  setConditions(props: any): void {
    this.manageConditions(props, 'inputs', 'field');
    this.manageConditions(props, 'labels', 'reference');
    this.manageConditions(props, 'functionKeys', 'key');
    this.manageGridConditions(props);
    if(this.props.formData['authorised']){
      this.manageAuthorization(props);
    }
    if(this.screenDef.hasContinueButton !== true){
      if(this.props.formData['hasContinueButton'] == true || (this.props.formData['programMode'] !== 'DSP' && this.props.formData['programMode'] !== 'SEL')){
       // this.screenDef.hasContinueButton = true;
       this.screenDef.hasContinueButton = this.props.formData['hasContinueButton'] ;        
      }
    }
  }

  /**
   * Hide the F6/F11/2/4 buttons and if user has access then it will be enabled
   * @param props
   */
  manageAuthorization(props: any) {
    let editOption = {};
    let editIndex = 0;
    let deleteOption = {};
    let deleteIndex = 0;
    const functionKeysToBeRemoved = [];
    const actionButtonToBeRemoved = [];
    if (this.conditions['functionKeys']["F6"]) this.conditions['functionKeys']["F6"]['hidden'] = true;
    if (this.conditions['functionKeys']["F11"]) this.conditions['functionKeys']["F11"]['hidden'] = true;
    for (let index = 0; index < props.screenDef.functionKeys.length; index++) {
      for (let index2 = 0; index2 < this.props.formData['removeFunctionKeys'].length; index2++) {
        if (this.props.formData['removeFunctionKeys'][index2]=== props.screenDef.functionKeys[index]['key']) {
          functionKeysToBeRemoved.push(props.screenDef.functionKeys[index]);
        }
      }
    }

    functionKeysToBeRemoved.forEach(functionKey => {
      const index = props.screenDef.functionKeys.indexOf(functionKey);
      if (index >= 0) {
        props.screenDef.functionKeys.splice(index, 1);
      }
    });

    if (props.screenDef.gridDefinition && props.screenDef.gridDefinition.actions) {
      for (let index = 0; index < props.screenDef.gridDefinition.actions.length; index++) {
        if (props.screenDef.gridDefinition.actions[index]['key'] == "2") {
          editOption = props.screenDef.gridDefinition.actions[index];
        } else if (props.screenDef.gridDefinition.actions[index]['key'] == "4") {
          deleteOption = props.screenDef.gridDefinition.actions[index];
        }
        for (let index1 = 0; index1 < this.formData['removeActionButtons'].length; index1++) {
          if (props.screenDef.gridDefinition.actions && props.screenDef.gridDefinition.actions[index] &&
            props.screenDef.gridDefinition.actions[index]['key'] === this.formData['removeActionButtons'][index1]) {
            actionButtonToBeRemoved.push(props.screenDef.gridDefinition.actions[index]);
          }
        }
      }
      editIndex = props.screenDef.gridDefinition.actions.indexOf(editOption);
      if (editIndex >= 0) props.screenDef.gridDefinition.actions.splice(editIndex, 1);
      deleteIndex = props.screenDef.gridDefinition.actions.indexOf(deleteOption);
      if (deleteIndex >= 0) props.screenDef.gridDefinition.actions.splice(deleteIndex, 1);

      actionButtonToBeRemoved.forEach(actionButton => {
        const actionButtonINdex = props.screenDef.gridDefinition.actions.indexOf(actionButton);
        if (actionButtonINdex >= 0) {
          props.screenDef.gridDefinition.actions.splice(actionButtonINdex, 1);
        }
      });
    }
    if (this.props.formData['portunusVerb']) {
      if (this.props.formData['portunusVerb']['INSERT'] === 'GRANT') {
        if (this.conditions.length === 0) {
          this.conditions['functionKeys'] = {};
        }
        if (this.conditions['functionKeys'] && this.conditions['functionKeys']["F6"])
          this.conditions['functionKeys']["F6"]['hidden'] = false;
      }
      if (this.props.formData['portunusVerb']['CHMODE'] === 'GRANT') {
        if (this.props.formData['programMode'] === 'DSP') {
          props.screenDef.functionKeys.splice(1, 0, { "key": "chmode", "command": "chmode", "label": "Edit" });
        } else {
          props.screenDef.functionKeys.splice(1, 0, { "key": "chmode", "command": "chmode", "label": "View" });
        }
      }
      if (this.props.formData['portunusVerb']['MODIFY'] === 'GRANT' && editIndex >= 0
        && props.screenDef.gridDefinition
        && props.screenDef.gridDefinition.actions.indexOf(editOption) < 0) {
        props.screenDef.gridDefinition.actions.splice(editIndex, 0, editOption);
      }
      if (this.props.formData['portunusVerb']['DELETE']  === 'GRANT') {
        if (this.conditions.length === 0) {
          this.conditions['functionKeys'] = {};
        }
        if (this.conditions['functionKeys'] && this.conditions['functionKeys']["F11"]) {
          this.conditions['functionKeys']["F11"]['hidden'] = false;
        }
        if (deleteIndex >= 0 && props.screenDef.gridDefinition
           && props.screenDef.gridDefinition.actions.indexOf(deleteOption) < 0) {
          props.screenDef.gridDefinition.actions.splice(deleteIndex, 0, deleteOption);
        }
      }
    }
  }

  /**
   * Apply a condition to a given container if a match is found in the
   * backend's response (formData).
   * @param condition the condition object
   * @param container the object containing the conditions
   */
  applyCondition(props: any, condition: any, container: any): any {
    // Split the conditionField string at every dot found
    if (condition && condition.conditionField) {
      if (this.isActiveCondition(props.formData, condition.conditionField)) {
        // Overwrite/Add the value to the conditions object (initial display)
        container[condition.attribute] = condition.attributeValue;
      }

      if (condition.attribute === 'hidden' && condition.applyToText === false) {
        // Manage labels conditions
        container.applyToText = false;
      }
    }
  }

  /**
   * Finds the condition value in the model.
   * @param obj object in which the condition must be found
   * @param path the path provided that leads to the condition
   */
  isActiveCondition(obj: any, path: string): boolean {
    const p = path.split('.');
    if (p.length > 1) {
      // Keep first index
      const accessor = p[0];
      // If accessor is found in the object
      if (obj[accessor]) {
        // Remove first index from path
        p.shift();
        return obj[accessor][p.join('.')];
      } else {
        // console.error(`Condition path not found in the model: ${path}`);
        return false;
      }
    }
    // console.error(`Condition path not found in the model: ${path}`);
    return false;
  }

  /**
   * Constructs a condition object for a specific element type.
   * {
   *   inputs: {
   *     inputName: {
   *       conditionName: conditionValue
   *     }
   *   }
   * }
   * @param elements The element type (inputs or functionKeys).
   * @param identifier The identifier for the given element.
   */
  manageConditions(props: any, elements: string, identifier: string): void {
    if (elements === 'inputs' || elements === 'functionKeys' || elements === 'labels') {
      if (props.screenDef[elements]) {
        // Initialize the conditions for this element
        this.conditions[elements] = {};
        // Loop every element in the screen
        props.screenDef[elements].forEach((element: any): void => {
          // Initialize an object for this specific element
          this.conditions[elements][element[identifier]] = {};
          // If the element has an initial display
          if (element.initialDisplay) {
            // Loop every display object
            element.initialDisplay.forEach((cond: any): void => {
              // Assign the display value to its attribute in the conditions object
              this.conditions[elements][element[identifier]][cond.attribute] = cond.attributeValue;
            });
          }
          // If the element has display conditions
          if (element.displayConditions) {
            // Loop every conditions
            element.displayConditions.forEach((condition: any): void => {
              this.applyCondition(props, condition, this.conditions[elements][element[identifier]]);
            });
          }
        });
      }
    }
  }

  /**
   * Same function as manageConditions, but targeted for conditions found in the
   * subfile of the DTO provided by the backend.
   */
  manageGridConditions(props: any): void {
    // Initialize the conditions for this grid
    this.conditions.grid = {
      gridSelection: {
        rows: {}
      },
      filters: {},
      actions: {}
    };
    if (props.screenDef.gridDefinition) {
      const gridDefinition = props.screenDef.gridDefinition;

      // Selection conditions
      if (gridDefinition.selectionConditions) {
        // Initial display
        if (gridDefinition.selectionConditions.initialDisplay) {
          gridDefinition.selectionConditions.initialDisplay.forEach((c: any): void => {
            this.conditions.grid.gridSelection[c.attribute] = c.attributeValue;
          });
        }
        // Display conditions
        if (gridDefinition.selectionConditions.displayConditions && props.formData.subfile) {
          gridDefinition.selectionConditions.displayConditions.forEach((c: any): any => {
            if (c && c.conditionField) {
              this.applyCondition(props, c, this.conditions.grid.gridSelection);
              // Check for specific row condition
              props.formData.subfile.forEach((row: any, index: number): void => {
                if (this.isActiveCondition(row, c.conditionField)) {
                  const value = c.attributeValue;
                  if (this.conditions.grid.gridSelection.rows[index.toString()] === undefined) {
                    this.conditions.grid.gridSelection.rows[index.toString()] = {};
                  }
                  this.conditions.grid.gridSelection.rows[index.toString()][c.attribute] = value;
                }
              });
            }
          });
        }
      }

      // Action buttons
      if (gridDefinition.actions) {
        gridDefinition.actions.forEach((a: any): void => {
          this.conditions.grid.actions[a.key] = {};

          if (a.initialDisplay) {
          this.conditions.grid.actions[a.key] = {};
            a.initialDisplay.forEach((c: any): void => {
              this.conditions.grid.actions[a.key][c.attribute] = c.attributeValue;
            });
          }

          if (a.displayConditions) {
            // this.conditions.grid.actions[a.key] = {};
            a.displayConditions.forEach((c: any): void => {
              this.applyCondition(props, c, this.conditions.grid.actions[a.key]);
            });
          }
        });
      }

      // Retrieve all columns
      const columns = gridDefinition.columns;
      // Loop all columns
      columns.forEach((column: any): void => {
        // Initialize an array of conditions for this specific column
        let columnConditions = {};
        // Loop every cell of a column
        column.forEach((cell: any): void => {
          // Keep for backwards compatibility with f-grid-cell (must have 'editable' property)
          cell.editable = true;
          // Initialize a conditions object for this specific cell
          const cellConditions: any = {
            rows: {}
          };
          // If the column has an initial display
          if (cell.initialDisplay) {
            // Loop every display object
            cell.initialDisplay.forEach((cond: any): void => {
              // Assign the display value to its attribute in the conditions object
              cellConditions[cond.attribute] = cond.attributeValue;
            });
            columnConditions = cellConditions;
          }
          // If the column has display conditions
          if (cell.displayConditions && props.formData.subfile) {
            // Loop every conditions
            cell.displayConditions.forEach((condition: any): void => {
              if (condition && condition.conditionField) {
                this.applyCondition(props, condition, cellConditions);
                // Check for single cell conditions
                props.formData.subfile.forEach((row: any, index: number): void => {
                  if (this.isActiveCondition(row, condition.conditionField)) {
                    const value = condition.attributeValue;
                    if (cellConditions.rows[index.toString()] === undefined) {
                      cellConditions.rows[index.toString()] = {};
                    }
                    cellConditions.rows[index.toString()][condition.attribute] = value;
                  }
                });
              }
            });
          }
          // If cell has filters
          if (cell.filters && cell.filters.length) {
            cell.filters.forEach((filter: any): void => {
              // Create object to store conditions for this filter
              if (this.conditions.grid.filters[filter.field] === undefined) {
                this.conditions.grid.filters[filter.field] = {};
              }
              // Initial display
              if (filter.initialDisplay) {
                filter.initialDisplay.forEach((condition: any): void => {
                  this.conditions.grid.filters[filter.field][condition.attribute] = condition.attributeValue;
                });
              }
              // Display Conditions
              if (filter.displayConditions) {
                filter.displayConditions.forEach((condition: any): void => {
                  this.applyCondition(props, condition, this.conditions.grid.filters[filter.field]);
                });
              }
            });
          }
        });
        this.conditions.grid[column[0].field] = columnConditions;
      });
    }
  }

  /**
   * Returns the value of an attribute for a specific element.
   * @param container object containing conditions
   * @param inputID the ID of the element (field name)
   * @param attribute the condition attribute
   */
  getCondition(container: any, inputID: string, attribute: string): any {
    if (container && container[inputID]) {
      return container[inputID][attribute];
    }
  }

  /**
   * Checks if an input is hidden but its label isn't
   * @param inputID the ID of the input (field name)
   */
  alwaysVisibleLabel(inputID: any): boolean {
    if (this.conditions && this.conditions.inputs && this.conditions.inputs[inputID]) {
      const condition = this.conditions.inputs[inputID];
      // Returns true if input is hidden but label is not
      return condition.hidden === true && condition.applyToText !== undefined && condition.applyToText === false;
    }
    return false;
  }

  // ================================================================
  //  TOOLBAR
  // ================================================================

  getToolbarClasses(): string {
    const classes = [];
    if (this.props.formData && this.props.formData.modalScreen) {
      classes.push('popup-keys');
    }
    if (this.funKeyPos === 'bottom') {
      classes.push('bottom');
    }
    return classes.join(' ');
  }

  // ================================================================
  //  INPUTS
  // ================================================================

  /**
   * Returns the CSS classes defining the item.
   */
  getItemClasses(item: any): string {
    const classes: string[] = ['col'];

    if (item) {
      if(item.fieldSize){
        classes.push('col-' + item.fieldSize);
      }
      else if (item.size) {
        classes.push('col-' + item.size);
      }

      if (item.type === 'label' || item.isLabel) {
        classes.push('label-col');
      }

      if (!item.label) {
        classes.push('no-label');
      }

      if (item.displayFormat) {
        if (item.displayFormat.textAlign) {
          classes.push(`align-${item.displayFormat.textAlign}`);
        }
      }

      if (item.addClass) {
        item.addClass.forEach((c: string) => {
          classes.push(c);
        });
      }
    }

    return classes.join(' ').toString();
  }

  /**
   * Splits inputs into rows, based on 'y' positionning.
   */
  formatInputs(screenDef: any): any[] {
    const localInput = screenDef.inputs ? JSON.parse(JSON.stringify(screenDef.inputs)) : [];

    // First, convert new label component and add it to inputs
    if (screenDef.labels && screenDef.labels.length > 0) {
      screenDef.labels.forEach((label: any) => {
        const newLabel = JSON.parse(JSON.stringify(label));
        newLabel.type = 'label';
        if (localInput.indexOf(newLabel) === -1) {
          // Add fake property (transform reference into field just to render properly)
          newLabel.field = newLabel.reference;
          localInput.push(newLabel);
        }
      });

      // Re-order based on pos.y and pos.x
      localInput.sort(function (a: any, b: any) {
        if (a.pos.y < b.pos.y) {
          return -1;
        } else if (a.pos.y > b.pos.y) {
          return 1;
        } else {
          // equal then we check the x
          if (a.pos.x < b.pos.x) {
            return -1;
          } else if (a.pos.x > b.pos.x) {
            return 1;
          }
          return 0;
        }
      });
    }

    const rows: any[] = [[]];
    let numRows = 1;
    let currentRow = (screenDef.inputs && screenDef.inputs.length) ? screenDef.inputs[0].pos.y : 0;
    // split inputs by rows
    localInput.forEach((input: any) => {
      const row = input.pos.y;
      if (currentRow !== row) {
        rows.push([]);
        currentRow = row;
        numRows++;
      }

      // If a grid exists in the page then we must check if field is before (99.9%) or after the grid (0.01%).
      // To do that, we just check if the Y position is greater or equal than 20 (because a grid, mostly occupied 10 rows and the latest (14 to 24))
      if (screenDef.gridDefinition) {
        if (input.pos.y >= 20) {
          input.pos.displayAtTheBottom = true;
        }
      }

      input.pos.y = numRows;

      rows[rows.length - 1].push(input);
    });

    return rows;
  }

  // ================================================================
  //  FUNCTION KEYS
  // ================================================================
  /**
   * Formats function keys to support grouping.
   */
  formatFunctionKeys(): any {
    const keys: any[] = [];

    if (this.props.screenDef.functionKeys && this.props.screenDef.functionKeys.length) {
      this.props.screenDef.functionKeys.forEach((functionKey: any): void => {
        // Get condition related attributes
        const conditions = this.conditions.functionKeys[functionKey.key];
        const hidden = conditions && conditions.hidden;
        const label = (conditions && conditions.label) ? conditions.label : functionKey.label;
        const disabled = conditions && conditions.protect;
        const key = functionKey.key;
        if (!hidden) {
          if (functionKey.group && functionKey.group !== 
            '' && window.config['ui']['funKeyGroups']) {
            // Get group of name
            let group = keys.find((obj: any): any => obj.label === functionKey.group);
            // Add group if it doesn't exist
            if (!group) {
              /* eslint-disable */
              keys.push({
                label: functionKey.group,
                items: [[]],
                template: (item: any, _options: any): any => {
                  return (
                    <span data-pr-tooltip={key}>{item.label}</span>
                  );
                }
              });
              /* eslint-enable */
            }
            // Get group of name again
            group = keys.find((obj: any): any => obj.label === functionKey.group);

            // Add item to group
            /* eslint-disable */
            group.items[0].push(
              {
                label: key, // Not displayed but fix an error about unique key for object in React
                items: [{
                  label,
                  disabled,
                  command: (): any => {
                    this.defaultAction(functionKey.command);
                  },
                  template: (item: any, options: any): any => {
                    return (
                      <React.Fragment>
                        <Tooltip target=".custom-tooltip-submenuitem" position="top" />
                        <a href="#" className={`p-menuitem-link custom-tooltip-submenuitem ${functionKey.addClass ? functionKey.addClass.join(' ') : ''}`} role="menuitem" aria-haspopup="false" data-pr-tooltip={key} target={item.target} onClick={options.onClick}>
                          {functionKey.image && (<img src={functionKey.image} className="custom-image" />)}
                          <div className="fcnkey-label">{item.label}</div>
                          <div className="fcnkey-key">{key}</div>
                        </a>
                      </React.Fragment>
                    );
                  }
                }]
              }
            );
            /* eslint-enable */
          } else {
            /* eslint-disable */
            keys.push({
              label,
              disabled,
              command: (): any => {
                this.defaultAction(functionKey.command);
              },
              template: (item: any, _options: any): any => {
                return (
                  <React.Fragment>
                    <Tooltip target=".custom-tooltip-functionkey" position="top" />
                    {functionKey.image && (<img src={functionKey.image} className="custom-image" />)}
                    <span data-pr-tooltip={key} className={`custom-tooltip-functionkey ${functionKey.addClass ? functionKey.addClass.join(' ') : ''}`}>{item.label}</span>
                  </React.Fragment>
                );
              }
            });
            /* eslint-enable */
          }
        }
      });
    }

    return keys;
  }

  /**
   * Returns the options with translated labels
   */
  getDropdownValues(options: any, field: string): any {
    // First if dropdownOptions are in the model for this field
    if (this.formData && this.formData['dropdownOptions'] && this.formData['dropdownOptions'][field]) {
      // Clear options (if they are declared in screen definition)
      options = [];

      // Add to options
      this.formData['dropdownOptions'][field].forEach((option: any, index: number): void => {
        options.push({ value: option.code, label: option.description });
      });
    }

    return options;
  }

  /**
   * Event called when an input is focused
   */
  onFieldFocus(fieldName: string, shortFieldName: string): void {
    this.focusedField = fieldName;
    this.focusedFieldId = shortFieldName;
    // row zero means no row in datatable
    this.tablerowFocusedField = -1;
  }

  getRightLabelClass(input: any): string {
    return 'right-label col col-' + (input.size + input.label.length + 1);
  }

  // ================================================================
  //  GRID
  // ================================================================

  /**
   * Grid event on field focus
   */
  onTableFieldFocus(fieldName: string, shortFieldName: string, rowNumber: number): void {
    this.focusedField = fieldName;
    this.focusedFieldId = shortFieldName;
    this.tablerowFocusedField = rowNumber % this.props.formData['subfilePageSize'];
  }

  /**
   * code on table action buttons, setprogramMode if delete, and
   * affect recordDataChanged and selected of selected rows..
   * and call reply
   */
  tableAction(action: any): void {
    this.showLoader();
    if (action.useItAsFunctionKey) {
      this.defaultAction(action.command);
    } else {
      const replyFormData = this.formData;
      for (let i = 0; i < replyFormData['subfile'].length; i++) {
        if (replyFormData['subfile'][i]['recordSelected'] === 'Y') {
          replyFormData['subfile'][i]['recordDataChanged'] = 'Y';
          replyFormData['subfile'][i][this.selectedActionField] = action.command;
        }
      }

      // if(tenant != undefined) {
      //   this.updateTenant(tenant);
      // }

      replyFormData['gridAction'] = action.command;
      replyFormData['cmdKey'] = '00';

      this.replyToBackend(replyFormData);
    }
  }

  /**
   * after page change, sent reply
   * Event:
   *    pageOfPages: boolean,
   *    direction: 'next' or 'previous',
   *    pageNumber: page to display),
   *    pageSize: total of record in the page
   */
  pageChanged(event: any): void {
    // if page has a grid and is the active page
    this.showLoader();

    const replyFormData = this.formData;
    if (event.pageOfPages) {
      // When page of pages feature is active, the we send 00 and the page
      replyFormData['cmdKey'] = "00";
      replyFormData['subfilePageNumber'] = event.pageNumber;
    } else {
      if (event.direction === 'previous') {
        replyFormData['cmdKey'] = window.config['keys'] ? window.config['keys']['PageUp'] : '07';
      } else if (event.direction === 'next') {
        replyFormData['cmdKey'] = window.config['keys'] ? window.config['keys']['PageDown'] : '08';
      } else if (event.direction === 'reset') { 
        replyFormData['cmdKey'] = window.config['keys'] ? window.config['keys']['Reset'] : '05';
      }
    }
    this.formData.gridExport = false;
    this.replyToBackend(replyFormData);
  }

  /**
   * Returns if the page should show the grid, based on the
   * 'screenControl' variables passed from the DTO.
   */
  showGrid(): boolean {
    return this.props.formData && (this.props.formData['screenControl'] === undefined || this.props.formData['screenControl'] !== 'H');
  }

  /**
   * returns the max length of a filter based on its definitions
   */
  getFilterMaxLength(column: any, filter: any): number {
    if (filter.displayFormat && filter.displayFormat.textLength !== undefined && filter.displayFormat.textLength > 0) {
      return filter.displayFormat.textLength;
    } else if (column.displayFormat && column.displayFormat.textLength) {
      return column.displayFormat.textLength;
    } else if (filter.textLength !== undefined && filter.textLength > 0) {
      return filter.textLength;
    } else if (column.textLength) {
      return column.textLength;
    }
  }

  /**
   * Grid Message handler - generate msg for each one contained in the DTO (duplicate message appearing on the grid in the toast messager)
   */
  onGridError(event: any): void {
    event.forEach((e: any): any => {
      toast.error((e.messageText + ' - ' + e.fieldsName.join(',')), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    });
  }

  // ================================================================
  //  BACKEND
  // ================================================================

  /**
   * code called from functionkeys
   */
  promptAction(fieldName: string, shortFieldName: string): void {
    this.showLoader();
    const replyFormData = this.formData;
    const command = '04'; // prompt command number = 04

    replyFormData['cursorField'] = fieldName;
    if (replyFormData['cursorFieldId'] !== undefined) {
      replyFormData['cursorFieldId'] = shortFieldName;
    }
    replyFormData['cursorTableRow'] = this.tablerowFocusedField;
    replyFormData['cmdKey'] = command;

    this.replyToBackend(replyFormData);
  }

  /**
   * code called from functionkeys
   */
  defaultAction(command: string): void {
    const replyFormData = this.formData;

    this.showLoader();

    replyFormData['cursorField'] = this.focusedField;
    if (replyFormData['cursorFieldId'] !== undefined) {
      replyFormData['cursorFieldId'] = this.focusedFieldId;
    }
    replyFormData['cursorTableRow'] = this.tablerowFocusedField;

    replyFormData['cmdKey'] = command;
    this.replyToBackend(replyFormData);
  }

  /**
   * When the user click on continue button
   */
  onSubmit(): void {
    // Prevent duplicate submissions from multiple event listeners
    if (this.isSubmitting) {
      console.log('Duplicate submission blocked');
      return;
    }

    if (this.isValid()) {
      this.isSubmitting = true;
      this.showLoader();

      const replyFormData = this.formData;

      replyFormData['cursorField'] = this.focusedField;
      if (replyFormData['cursorFieldId'] !== undefined) {
        replyFormData['cursorFieldId'] = this.focusedFieldId;
      }
      replyFormData['cursorTableRow'] = this.tablerowFocusedField;

      replyFormData['cmdKey'] = '00';
      replyFormData['gridExport'] = false;
      this.replyToBackend(replyFormData);
    } else {
      // To display error messages
      this.forceUpdate();
    }
  }

  convertArrayOfObjectsToCSV(array: any[]): any  {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';

    const keyObjs = this.screenDef.gridDefinition.columns.map( x=> {
      return x.length > 0 ? { key: x[0].field, header: x[0].header1} : {};
    })
    console.log('keyObjs=', keyObjs);

    const headers =keyObjs.map(h => h.header);
    const keys =keyObjs.map(h => h.key);
    const map = new Map<string, any>(this.formData.subfileFields.map((obj) => [obj.field, obj.index])); 
    result = '';
    result += headers.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        result += (item.fields[map.get(key)] + '').replace(',', ' ');
        // eslint-disable-next-line no-plusplus
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  downloadCSV(thisObj: any): void {
    console.log('myJsonDataArray=', thisObj.props.formData.exportSubFileList);

    const csv: any = thisObj.convertArrayOfObjectsToCSV(thisObj.props.formData.exportSubFileList);
    if (csv == null) return;
    let exportedFilename: any;
    if (thisObj.screenDef.showReport) {
      exportedFilename = thisObj.screenDef.reportName + '.csv' || 'export.csv';
    } else {
      exportedFilename = thisObj.screenDef.programName + '.csv' || 'export.csv';
    }
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if ((navigator as any).msSaveBlob) {
      (navigator as any).msSaveBlob(blob, exportedFilename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', exportedFilename)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

  onGridSearchSubmit(): void {
        this.exported = false;
        this.showLoader();
        const replyFormData = this.formData;
        replyFormData['cursorField'] = this.focusedField;
        if (replyFormData['cursorFieldId'] !== undefined) {
            replyFormData['cursorFieldId'] = this.focusedFieldId;
        }
        replyFormData['cursorTableRow'] = this.tablerowFocusedField;
        replyFormData['cmdKey'] = '00';
        replyFormData['gridExport'] = true;
        console.log('onGridSearchSubmit replyFormData=', replyFormData);
        model.next({
            data: replyFormData
        });
        this.terminal.reply();
    }


    // [{"field":"rcd.rblListDescription","index":0},{"field":"rcd.rblRebateListId","index":1}]
    getSubfileFieldIndex = (fieldName: string, newFormData: any) => {
     const field = newFormData.subfileFields.find((item: any) => item.field == fieldName);
     return field ? field.index : -1;
   }

  /**
   * Because we need to set data for terminal lib
   */
  replyToBackend(newFormData: any): void {
    if(AuthProxy.getJumpParams()) {
      const handled = this.crossSliceJump(newFormData);
      if (handled) return;
    }

    //Fresche to AI
    // RCRT2003I
    if(newFormData.gridAction == "5" &&
      newFormData.nextScreen == "realtimepricing/rcrt2001idsprealtimepricingprofilerules") {
      const mediatorId = newFormData.mediatorId;
      let jumpParams = {};
      const selectedRecord = [];
      let params = {};
      params = {
        rt1CarrierId: newFormData.fields["ctl.wrkCarrierId"],
        wrkCarrierName: newFormData.fields["ctl.wrkCarrierName"],
        rt1AccountId: newFormData.fields["ctl.wrkAccountId"],
        wrkAccountName: newFormData.fields["ctl.wrkAccountName"],
        rt1GroupId: newFormData.fields["ctl.wrkGroupId"],
        wrkGroupName: newFormData.fields["ctl.wrkGroupName"],
        planCode: newFormData.fields["ctl.wrkPlanCode"],
        wrkPlanName: newFormData.fields["ctl.wrkPlanName"],
        planEffDate: newFormData.fields["ctl.wrkPlanEffDate"]
      }
    
      newFormData.subfile.forEach(item => {
        if (item.selected !== "") {
          selectedRecord.push({
            rt2DaysSupply: item.fields[0],
            rt2Affiliate: item.fields[1],
            rt2State: item.fields[2],
            rt2MultiSourceCode: item.fields[3],
            rt2Seq: item.fields[7]
          });
          jumpParams = { "screenParams": params, "selectedRecords": selectedRecord, "mediatorId": mediatorId }
        }
    });

    window.parent.postMessage(
      {
          message: "new-navigate-to-ai-program",
          programCode: "RCRT2003I",
          parameters: jumpParams
      }, '*')
    }
//RCPRC004 to RCSAS003
if (newFormData.nextScreen === "prcPriceSchedule/rcprc004EditPriceSchedPanel" && newFormData.cmdKey != 12 && newFormData.cmdKey == "16") {
      console.log("Inside cross slice jump for RCPRC004");
      const mediatorId = newFormData.mediatorId;
      let screenParams = {};
      const selectedRecords = [];     
       
      screenParams = {
        prcPriceScheduleName: newFormData.fields["dtl.prcPriceScheduleName"],
        prcPriceScheduleDesc: newFormData.fields["dtl.prcPriceScheduleDesc"],
        activeOrHidden : newFormData.fields["dtl.activeOrHidden "]
      };

      selectedRecords.push({
        prcPriceScheduleName: newFormData.fields["dtl.prcPriceScheduleName"],
        prcPriceScheduleDesc: newFormData.fields["dtl.prcPriceScheduleDesc"],
        activeOrHidden: newFormData.fields["dtl.activeOrHidden "]
      });
       
    
      window.parent.postMessage(
            {
                message: "new-navigate-to-ai-program",
                programCode: "RCSAS002",
                parameters: {
                  screenParams: screenParams,
                  selectedRecords: selectedRecords,
                  mediatorId: mediatorId,
                  returnProgramCode: "RCPRC004"
                }
            }, '*')

    }
    //RCPRC003 to RCSAS003
	if (newFormData.nextScreen === "prcPriceSchedule/rcprc003DspPriceSched" && newFormData.cmdKey != 12 && newFormData.gridAction == "16") {
      console.log("Inside cross slice jump for RCPRC003");
      const mediatorId = newFormData.mediatorId;
       console.log("Mediator ID for RCPRC003: ", mediatorId);
      console.log("New Form Data for RCPRC003: ", newFormData);
      console.log("Subfile for RCPRC003: ", newFormData.subfile);
      console.log("newFormData payload for RCPRC003:", JSON.stringify(newFormData, null, 2));
      let screenParams = {};
      const selectedRecords = [];
      const prcPriceScheduleDescIndex = this.getSubfileFieldIndex("rcd.prcPriceScheduleDesc", newFormData);
      const prcPriceScheduleNameIndex = this.getSubfileFieldIndex("rcd.prcPriceScheduleName", newFormData);
      const hiddenRecordIndicatorIndex = this.getSubfileFieldIndex("rcd.hiddenRecordIndicator", newFormData);

      newFormData.subfile.forEach(item => {
        if (item.selected !== "") {
          const selectedRecord = {
            prcPriceScheduleName: item.fields[prcPriceScheduleNameIndex],
            prcPriceScheduleDesc: item.fields[prcPriceScheduleDescIndex],
            activeOrHidden: item.fields[hiddenRecordIndicatorIndex]
          };

          selectedRecords.push(selectedRecord);
          screenParams = selectedRecord;
        }
      });
      
      window.parent.postMessage(
            {
                message: "new-navigate-to-ai-program",
                programCode: "RCSAS002",
                parameters: {
                  screenParams: screenParams,
                  selectedRecords: selectedRecords,
                  mediatorId: mediatorId,
                  returnProgramCode: "RCPRC003"
                }
            }, '*')
    }

    newFormData = this.addSubfileTopRRN(newFormData);
    newFormData = this.removeUselessDataFromPayload(newFormData);
    console.log(JSON.stringify(newFormData));
    console.log('replytobackend');
    this.terminal.reply();
  }

  crossSliceJump(newFormData: any): boolean | void {
    // RCTAX004
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "taxTaxSchedule/rctax004DispTaxSchedPanel") ||
    (newFormData.nextScreen == "taxTaxSchedule/rctax004DispTaxSchedPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const taxCountyCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxCountyCode", newFormData)];
          const taxSeqNbr = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxSeqNbr", newFormData)];
          const taxTaxScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleName", newFormData)];
          const taxTaxScheduleState = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleState", newFormData)];
          const taxTaxScheduleZip = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleZip", newFormData)];
          const taxTaxScheduleZip2 = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleZip2", newFormData)];
          const taxTaxScheduleZip3 = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleZip3", newFormData)];
          selection = {
            "taxCountyCode": taxCountyCode,
            "taxSeqNbr": taxSeqNbr,
            "taxTaxScheduleName": taxTaxScheduleName,
            "taxTaxScheduleState": taxTaxScheduleState,
            "taxTaxScheduleZip": taxTaxScheduleZip,
            "taxTaxScheduleZip2": taxTaxScheduleZip2,
            "taxTaxScheduleZip3": taxTaxScheduleZip3
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.taxCountyCode = selection["taxCountyCode"];
      newState[newState.length - 1].paramsData.taxSeqNbr = selection["taxSeqNbr"];
      newState[newState.length - 1].paramsData.taxTaxScheduleName = selection["taxTaxScheduleName"];
      newState[newState.length - 1].paramsData.taxTaxScheduleState = selection["taxTaxScheduleState"];
      newState[newState.length - 1].paramsData.taxTaxScheduleZip = selection["taxTaxScheduleZip"];
      newState[newState.length - 1].paramsData.taxTaxScheduleZip2 = selection["taxTaxScheduleZip2"];
      newState[newState.length - 1].paramsData.taxTaxScheduleZip3 = selection["taxTaxScheduleZip3"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }


    // RCFSC004I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "fscFeeSchedule/rcfsc004iDspFeeSchStpPanel") ||
     newFormData.nextScreen == "fscFeeSchedule/rcfsc004iDspFeeSchStpPanel" && newFormData.cmdKey == "12") {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const fscFeeScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fscFeeScheduleName", newFormData)];
           const fscStepNbrInFeeSched = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fscStepNbrInFeeSched", newFormData)];
           const fshFeeScheduleDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleDesc", newFormData)];
           selection = {
             "fscFeeScheduleName":fscFeeScheduleName,
             "fscStepNbrInFeeSched":fscStepNbrInFeeSched,
             "fshFeeScheduleDesc":fshFeeScheduleDesc
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.fscFeeScheduleName = selection["fscFeeScheduleName"];
       newState[newState.length - 1].paramsData.fscStepNbrInFeeSched = selection["fscStepNbrInFeeSched"];
       newState[newState.length - 1].paramsData.fshFeeScheduleDesc = selection["fshFeeScheduleDesc"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCMLS003
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "mlsMacListSchedule/rcmls003EdtMlsPanel") ||
    (newFormData.nextScreen == "mlsMacListSchedule/rcmls003EdtMlsPanel" && newFormData.cmdKey == "12" 
    && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 && 
    newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 0 ? AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen : '';
      let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const mlsSchedule = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.mlsSchedule", newFormData)];
           const workInitialProgramMode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.workInitialProgramMode", newFormData)];
           selection = {
             "mlsSchedule":mlsSchedule,
             "workInitialProgramMode": workInitialProgramMode
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.mlsSchedule = selection["mlsSchedule"];
       newState[newState.length - 1].paramsData.workInitialProgramMode = selection["workInitialProgramMode"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCPAD001I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "padPharmacyIdListDtl/rcpad001idspPadLstDtl") ||
     (newFormData.nextScreen == "padPharmacyIdListDtl/rcpad001idspPadLstDtl" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const palPharmacyIdListDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.palPharmacyIdListDesc", newFormData)];
           const palPharmacyIdListName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.palPharmacyIdListName", newFormData)];
           selection = {
             "palPharmacyIdListDesc":palPharmacyIdListDesc,
             "palPharmacyIdListName": palPharmacyIdListName
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.palPharmacyIdListDesc = selection["palPharmacyIdListDesc"];
       newState[newState.length - 1].paramsData.palPharmacyIdListName = selection["palPharmacyIdListName"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     // RCPS7005I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "ps7PriceBasisSchedule/rcps7005iDspPrcBasSchPanel") ||
     (newFormData.nextScreen == "ps7PriceBasisSchedule/rcps7005iDspPrcBasSchPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const ps7PriceBasisSched = newFormData.subfile[i].fields["rcd.ps7PriceBasisSched"];
           selection = {
             "ps7PriceBasisSched": ps7PriceBasisSched
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.ps7PriceBasisSched = selection["ps7PriceBasisSched"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCPAL004
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "palPharmacyIdList/rcpal004SelectPalList") ||
     newFormData.nextScreen == "palPharmacyIdList/rcpal004SelectPalList" && newFormData.cmdKey == "12") {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const palPharmacyIdListName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.palPharmacyIdListName", newFormData)];
           const palPharmacyIdListDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.palPharmacyIdListDesc", newFormData)];
           selection = {
             "palPharmacyIdListName": palPharmacyIdListName,
             "palPharmacyIdListDesc": palPharmacyIdListDesc
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.palPharmacyIdListName = selection["palPharmacyIdListName"];
       newState[newState.length - 1].paramsData.palPharmacyIdListDesc = selection["palPharmacyIdListDesc"];
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCPRC001, RCPRC004
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "prcPriceSchedule/rcprc004EditPriceSchedPanel") ||
     (newFormData.nextScreen == "prcPriceSchedule/rcprc004EditPriceSchedPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const prcPriceScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.prcPriceScheduleName", newFormData)];
           selection = {
             "prcPriceScheduleName": prcPriceScheduleName
           }
         }
       }
        const jumpParams = AuthProxy.getJumpParams();
        // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
        newState[newState.length - 1].paramsData.prcPriceScheduleName = selection["prcPriceScheduleName"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
    // RCGP1003I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gp1GpiList/rcgp1003iDspGpiListPanel") ||
     newFormData.nextScreen == "gp1GpiList/rcgp1003iDspGpiListPanel" && newFormData.cmdKey == "12") {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const gpiListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiListId", newFormData)];
           selection = {
             "gpiListId": gpiListId
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.gpiListId = selection["gpiListId"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     //RCGPM003I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gpmGppcMaster/rcgpm003iDspGppcMasterPanel") ||
     newFormData.nextScreen == "gpmGppcMaster/rcgpm003iDspGppcMasterPanel" && newFormData.cmdKey == "12") {
        if(newFormData.cmdKey == "12" &&
         AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiSelect == "Y") {
         const jumpParams = AuthProxy.getJumpParams();
         const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
         const rawMultiSelectData = currentState?.multiSelectData;
         const multiSelectData: any[] = Array.isArray(rawMultiSelectData)
           ? rawMultiSelectData
           : (rawMultiSelectData ? Object.values(rawMultiSelectData) : []);
         console.log("[RCGPM003I] multiSelectData count:", multiSelectData.length);
         const gpiIdNumber = newFormData.fields["key.gpiIdNumber"];
         const gpmGppcId = newFormData.fields["key.gpmGppcId"];
         const currentIndex = multiSelectData.findIndex((item: any) =>
           item.gpiIdNumber.trim() === gpiIdNumber.trim() &&
           item.gpmGppcId.trim() === gpmGppcId.trim()
         );
         const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiSelectData.length ? multiSelectData[currentIndex + 1] : null;
         if (nextRecord) {
           console.log("[RCGPM003I] navigating to next record:", nextRecord.gpiIdNumber, nextRecord.gpmGppcId);
           window.parent.postMessage({
             message: "navigate-to-program-internal",
             programCode: "RCGPM003I",
             parameters: [nextRecord.gpiIdNumber, nextRecord.gpmGppcId]
           }, '*');
           return;
         }
       }
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const gpiIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiIdNumber", newFormData)];
           const gpmGppcId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpmGppcId", newFormData)];
           selection = {
             "gpiIdNumber": gpiIdNumber,
             "gpmGppcId": gpmGppcId,

           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.gpiIdNumber = selection["gpiIdNumber"];
       newState[newState.length - 1].paramsData.gpmGppcId = selection["gpmGppcId"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     //RCGIN004
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "ginGenericIdNotes/rcgin004EditGppcNotes") ||
     (newFormData.nextScreen == "ginGenericIdNotes/rcgin004EditGppcNotes" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       if(newFormData.cmdKey == "12" &&
         AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiSelect == "Y") {
         const jumpParams = AuthProxy.getJumpParams();
         const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
         const rawMultiSelectData = currentState?.multiSelectData;
         const multiSelectData: any[] = Array.isArray(rawMultiSelectData)
           ? rawMultiSelectData
           : (rawMultiSelectData ? Object.values(rawMultiSelectData) : []);
         console.log("[RCGIN004] multiselectdata count:", multiSelectData.length);
         const ginGenericIdNumber = newFormData.fields["ctl.ginGenericIdNumber"];
         const currentIndex = multiSelectData.findIndex((item: any) =>
           item.ginGenericIdNumber.trim() === ginGenericIdNumber.trim()
         );
         const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiSelectData.length ? multiSelectData[currentIndex + 1] : null;
         if (nextRecord) {
           console.log("[RCGIN004] navigating to next record:", nextRecord.ginGenericIdNumber, nextRecord.ginGenericType);
           window.parent.postMessage({
             message: "navigate-to-program-internal",
             programCode: "RCGIN004",
             parameters: [nextRecord.ginGenericIdNumber, nextRecord.ginGenericType]
           }, '*');
           return;
         }
       }
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const ginGenericIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ginGenericIdNumber", newFormData)];
           const ginGenericType = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ginGenericType", newFormData)];
           selection = {
             "ginGenericIdNumber": ginGenericIdNumber,
             "ginGenericType": ginGenericType,

           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.ginGenericIdNumber = selection["ginGenericIdNumber"];
       newState[newState.length - 1].paramsData.ginGenericType = selection["ginGenericType"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCGP1004
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gp1GpiList/rcgp1004SelectGpiList") ||
     (newFormData.nextScreen == "gp1GpiList/rcgp1004SelectGpiList" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const gpiListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiListId", newFormData)];
           const gp1GpiListDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gp1GpiListDescription", newFormData)];
           selection = {
             "gpiListId": gpiListId,
             "gp1GpiListDescription": gp1GpiListDescription
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.gpiListId = selection["gpiListId"];
       newState[newState.length - 1].paramsData.gp1GpiListDescription = selection["gp1GpiListDescription"];
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     // RCDXT003I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "dxtPosRebateExclusion/rcdxt003iDspPosRbtExPanel") ||
     (newFormData.nextScreen == "dxtPosRebateExclusion/rcdxt003iDspPosRbtExPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 0 ? AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen : '';
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const dxtExclusionTableId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxtExclusionTableId", newFormData)];
           selection = {
             "dxtExclusionTableId": dxtExclusionTableId
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.dxtExclusionTableId = selection["dxtExclusionTableId"];
       
       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     // RCDXT006
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "dxtPosRebateExclusion/rcdxt006SelExclusionId") ||
     (newFormData.nextScreen == "dxtPosRebateExclusion/rcdxt006SelExclusionId" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const dxtExclusionTableId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxtExclusionTableId", newFormData)];
           const dxtExclusionDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxtExclusionDescription", newFormData)];
           selection = {
             "dxtExclusionTableId": dxtExclusionTableId,
             "dxtExclusionDescription": dxtExclusionDescription
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.dxtExclusionTableId = selection["dxtExclusionTableId"];
       newState[newState.length - 1].paramsData.dxtExclusionDescription = selection["dxtExclusionDescription"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
    // RCDXP001
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "dxpPartdPosRebateDtl/rcdxp001MntPosRbtAct") ||
    newFormData.nextScreen == "dxpPartdPosRebateDtl/rcdxp001MntPosRbtAct" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const dxrRebateDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxrRebateDescription", newFormData)];
          const dxrRebateTableId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxrRebateTableId", newFormData)];
          selection = {
            "dxrRebateDescription": dxrRebateDescription,
            "dxrRebateTableId": dxrRebateTableId,
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.dxrRebateDescription = selection["dxrRebateDescription"];
      newState[newState.length - 1].paramsData.dxrRebateTableId = selection["dxrRebateTableId"];
      
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
    
     // RCDXR004
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "dxrPartdPosRebate/rcdxr004SelPrtdPosReb") ||
     (newFormData.nextScreen == "dxrPartdPosRebate/rcdxr004SelPrtdPosReb" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const dxrRebateTableId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxrRebateTableId", newFormData)];
           const dxrRebateDescription= newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.dxrRebateDescription", newFormData)];
           selection = {
             "dxrRebateTableId": dxrRebateTableId,
             "dxrRebateDescription": dxrRebateDescription
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
 
       newState[newState.length - 1].paramsData.dxrRebateTableId = selection["dxrRebateTableId"];
       newState[newState.length - 1].paramsData.dxrRebateDescription = selection["dxrRebateDescription"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

    // RCRBP001
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "rbpPosRebateListProd/rcrbp001MntRbpAct") ||
    newFormData.nextScreen == "rbpPosRebateListProd/rcrbp001MntRbpAct" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const rblListDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rblListDescription", newFormData)];
          const rblRebateListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rblRebateListId", newFormData)];
          selection = {
            "rblListDescription": rblListDescription,
            "rblRebateListId" : rblRebateListId
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.rblListDescription = selection["rblListDescription"];
      newState[newState.length - 1].paramsData.rblRebateListId = selection["rblRebateListId"];
      
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }


    // RCRBL005
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "rblPosRebateList/rcrbl005SelRbl") ||
    newFormData.nextScreen == "rblPosRebateList/rcrbl005SelRbl" && newFormData.cmdKey == "12") {

      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const rblRebateListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rblRebateListId", newFormData)];
          const rblListDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rblListDescription", newFormData)];
          selection = {
            "rblRebateListId": rblRebateListId,
            "rblListDescription": rblListDescription
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.rblRebateListId = selection["rblRebateListId"];
      newState[newState.length - 1].paramsData.rblListDescription = selection["rblListDescription"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

     // RCTAX005
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "taxTaxSchedule/rctax005SelectTaxSched") ||
    (newFormData.nextScreen == "taxTaxSchedule/rctax005SelectTaxSched" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const taxCountyCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxCountyCode", newFormData)];
          const taxTaxScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleName", newFormData)];
          const taxTaxScheduleState = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleState", newFormData)];
          const taxTaxScheduleZip = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.taxTaxScheduleZip", newFormData)];
          selection = {
            "taxCountyCode": taxCountyCode,
            "taxTaxScheduleName": taxTaxScheduleName,
            "taxTaxScheduleState": taxTaxScheduleState,
            "taxTaxScheduleZip": taxTaxScheduleZip
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.taxCountyCode = selection["taxCountyCode"];
      newState[newState.length - 1].paramsData.taxTaxScheduleName = selection["taxTaxScheduleName"];
      newState[newState.length - 1].paramsData.taxTaxScheduleState = selection["taxTaxScheduleState"];
      newState[newState.length - 1].paramsData.taxTaxScheduleZip = selection["taxTaxScheduleZip"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
    // RCADS004
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "adsAmountDueSchedule/rcads004SltAmtDueSch") ||
    (newFormData.nextScreen == "adsAmountDueSchedule/rcads004SltAmtDueSch" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const adsScheduleId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.adsScheduleId", newFormData)];
          const adsScheduleDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.adsScheduleDescription", newFormData)];
          
          selection = {
            "adsScheduleId": adsScheduleId,
            "adsScheduleDescription": adsScheduleDescription
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.adsScheduleId = selection["adsScheduleId"];
      newState[newState.length - 1].paramsData.adsScheduleDescription = selection["adsScheduleDescription"];
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    // RCADS003I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "adsAmountDueSchedule/rcads003iDspAmtDueSchPanel") ||
    (newFormData.nextScreen == "adsAmountDueSchedule/rcads003iDspAmtDueSchPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const adsScheduleId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.adsScheduleId", newFormData)];
          selection = {
            "adsScheduleId": adsScheduleId
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.adsScheduleId = selection["adsScheduleId"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
    // RCNRB003
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "nrbPhrmntwkRateschedule/rcnrb003ChgPhnWrateschPanel") ||
    (newFormData.nextScreen == "nrbPhrmntwkRateschedule/rcnrb003ChgPhnWrateschPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const nrbScheduleDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.nrbScheduleDescription", newFormData)];
          const nrbScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.nrbScheduleName", newFormData)];
          const workInitialProgramMode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.workInitialProgramMode", newFormData)];
          selection = {
            "nrbScheduleDescription": nrbScheduleDescription,
            "nrbScheduleName": nrbScheduleName,
            "workInitialProgramMode": workInitialProgramMode
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.nrbScheduleDescription = selection["nrbScheduleDescription"];
      newState[newState.length - 1].paramsData.nrbScheduleName = selection["nrbScheduleName"];
      newState[newState.length - 1].paramsData.workInitialProgramMode = selection["workInitialProgramMode"];
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
    // RCNRC001I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "nrcPhrmntwkRateschDtl/rcnrc001iDspRateActive") ||
    newFormData.nextScreen == "nrcPhrmntwkRateschDtl/rcnrc001iDspRateActive" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const nrbScheduleDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.nrbScheduleDescription", newFormData)];
          const nrbScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.nrbScheduleName", newFormData)];
          selection = {
            "nrbScheduleDescription": nrbScheduleDescription,
            "nrbScheduleName": nrbScheduleName
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.nrbScheduleDescription = selection["nrbScheduleDescription"];
      newState[newState.length - 1].paramsData.nrbScheduleName = selection["nrbScheduleName"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    //RCGP2001I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gp2GpiListDetail/rcgp2001iDspByGpiNbr") ||
    (newFormData.nextScreen == "gp2GpiListDetail/rcgp2001iDspByGpiNbr" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen
      && !AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen.startsWith("/"))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gp1GpiListDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gp1GpiListDescription", newFormData)];
          const gpiListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiListId", newFormData)];
          const gp2GpiDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gp2GpiDescription", newFormData)];
          selection = {
            "gp1GpiListDescription": gp1GpiListDescription,
            "gpiListId": gpiListId,
            "gp2GpiDescription": gp2GpiDescription
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.gp1GpiListDescription = selection["gp1GpiListDescription"];
      newState[newState.length - 1].paramsData.gpiListId = selection["gpiListId"];
      newState[newState.length - 1].paramsData.gp2GpiDescription = selection["gp2GpiDescription"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

     //RCFSN001I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "fsnFeeScheduleNotes/rcfsn001iDspFeeSchNot") ||
    newFormData.nextScreen == "fsnFeeScheduleNotes/rcfsn001iDspFeeSchNot" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const fshFeeScheduleDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleDesc", newFormData)];
          const fshFeeScheduleId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleId", newFormData)];
          selection = {
            "fshFeeScheduleDesc": fshFeeScheduleDesc,
            "fshFeeScheduleId": fshFeeScheduleId
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.fshFeeScheduleDesc = selection["fshFeeScheduleDesc"];
      newState[newState.length - 1].paramsData.fshFeeScheduleId = selection["fshFeeScheduleId"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    //RCFSH003I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "fshFeeScheduleHeader/rcfsh003iDspFeeSchedPanel") ||
    newFormData.nextScreen == "fshFeeScheduleHeader/rcfsh003iDspFeeSchedPanel" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const fshFeeScheduleId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleId", newFormData)];
         
          selection = {
            "fshFeeScheduleId": fshFeeScheduleId
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.fshFeeScheduleId = selection["fshFeeScheduleId"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    //RCFSC002I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "fscFeeSchedule/rcfsc002iDspFeeSchStp") ||
    newFormData.nextScreen == "fscFeeSchedule/rcfsc002iDspFeeSchStp" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const fscFeeScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fscFeeScheduleName", newFormData)];
          const fshFeeScheduleDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleDesc", newFormData)];
          selection = {
            "fscFeeScheduleName": fscFeeScheduleName,
            "fshFeeScheduleDesc": fshFeeScheduleDesc
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.fscFeeScheduleName = selection["fscFeeScheduleName"];
      newState[newState.length - 1].paramsData.fshFeeScheduleDesc = selection["fshFeeScheduleDesc"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    //RCFSN001
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "fsnFeeScheduleNotes/rcfsn001MntFeeSchNote") ||
    (newFormData.nextScreen == "fsnFeeScheduleNotes/rcfsn001MntFeeSchNote" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const fshFeeScheduleDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleDesc", newFormData)];
          const fshFeeScheduleId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.fshFeeScheduleId", newFormData)];
          const workInitialProgramMode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.workInitialProgramMode", newFormData)];
          selection = {
            "fshFeeScheduleDesc": fshFeeScheduleDesc,
            "fshFeeScheduleId": fshFeeScheduleId,
            "workInitialProgramMode":workInitialProgramMode
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.fshFeeScheduleDesc = selection["fshFeeScheduleDesc"];
      newState[newState.length - 1].paramsData.fshFeeScheduleId = selection["fshFeeScheduleId"];
      newState[newState.length - 1].paramsData.workInitialProgramMode = selection["workInitialProgramMode"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    //RCPID009
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "pidProductId/rcpid009ProdByGpiAct") ||
    newFormData.nextScreen == "pidProductId/rcpid009ProdByGpiAct" && newFormData.cmdKey == "12") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gpiIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiIdNumber", newFormData)];
          selection = {
            "gpiIdNumber": gpiIdNumber
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      newState[newState.length - 1].paramsData.gpiIdNumber = selection["gpiIdNumber"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    // RCMD1001
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "md1MacListSchedDetail/rcmd1001DspMd1Active") ||
     (newFormData.nextScreen == "md1MacListSchedDetail/rcmd1001DspMd1Active" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const mlsDescription = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.mlsDescription", newFormData)];
           const mlsSchedule = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.mlsSchedule", newFormData)];
           selection = {
             "mlsDescription":mlsDescription,
             "mlsSchedule": mlsSchedule
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.mlsDescription = selection["mlsDescription"];
       newState[newState.length - 1].paramsData.mlsSchedule = selection["mlsSchedule"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     // RCPSC002
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "pscPriceSchedCriteria/rcpsc002PrcschcrtMnt") ||
     (newFormData.nextScreen == "pscPriceSchedCriteria/rcpsc002PrcschcrtMnt" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const prcPriceScheduleDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.prcPriceScheduleDesc", newFormData)];
           const prcPriceScheduleName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.prcPriceScheduleName", newFormData)];
           selection = {
             "prcPriceScheduleDesc":prcPriceScheduleDesc,
             "prcPriceScheduleName": prcPriceScheduleName
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.prcPriceScheduleDesc = selection["prcPriceScheduleDesc"];
       newState[newState.length - 1].paramsData.prcPriceScheduleName = selection["prcPriceScheduleName"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     // RCPS8001
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "ps8PriceBasisDetail/rcps8001DspPrcBasDtl") ||
     (newFormData.nextScreen == "ps8PriceBasisDetail/rcps8001DspPrcBasDtl" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const ps7PriceBasisDescrip = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ps7PriceBasisDescrip", newFormData)];
           const ps7PriceBasisSched = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ps7PriceBasisSched", newFormData)];
           selection = {
             "ps7PriceBasisDescrip":ps7PriceBasisDescrip,
             "ps7PriceBasisSched": ps7PriceBasisSched
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.ps7PriceBasisDescrip = selection["ps7PriceBasisDescrip"];
       newState[newState.length - 1].paramsData.ps7PriceBasisSched = selection["ps7PriceBasisSched"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }

     // RCRBL003
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "rblPosRebateList/rcrbl003EdtRblPanel") ||
     newFormData.nextScreen == "rblPosRebateList/rcrbl003EdtRblPanel" && newFormData.cmdKey == "12") {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const rblRebateListId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rblRebateListId", newFormData)];
           const workInitialProgramMode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.workInitialProgramMode", newFormData)];
           selection = {
             "rblRebateListId":rblRebateListId,
             "workInitialProgramMode": workInitialProgramMode
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.rblRebateListId = selection["rblRebateListId"];
       newState[newState.length - 1].paramsData.workInitialProgramMode = selection["workInitialProgramMode"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     // RCSTL002I
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "stlStateList/rcstl002iDspStateListPanel") ||
     newFormData.nextScreen == "stlStateList/rcstl002iDspStateListPanel" && newFormData.cmdKey == "12"){
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const stlStateListName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.stlStateListName", newFormData)];
           selection = {
             "stlStateListName":stlStateListName
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.stlStateListName = selection["stlStateListName"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     //RCGRP016
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "grpGroup/rcgrp016SelectGroup") ||
      (newFormData.nextScreen == "grpGroup/rcgrp016SelectGroup" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const accAccountId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.accAccountId", newFormData)];
           const carCarrierId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.carCarrierId", newFormData)];
           const grpGroupId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.grpGroupId", newFormData)];
           selection = {
             "accAccountId": accAccountId,
             "carCarrierId": carCarrierId,
             "grpGroupId": grpGroupId
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.accAccountId = selection["accAccountId"];
       newState[newState.length - 1].paramsData.carCarrierId = selection["carCarrierId"];
       newState[newState.length - 1].paramsData.grpGroupId = selection["grpGroupId"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     //RCGRP030
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "grpGroup/rcgrp030SelectGroup") ||
      (newFormData.nextScreen == "grpGroup/rcgrp030SelectGroup" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const accAccountId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.accAccountId", newFormData)];
           const carCarrierId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.carCarrierId", newFormData)];
           const grpGroupId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.grpGroupId", newFormData)];
           const wrkFKeySts = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.wrkFKeySts", newFormData)];
           selection = {
             "accAccountId": accAccountId,
             "carCarrierId": carCarrierId,
             "grpGroupId": grpGroupId,
             "wrkFKeySts": wrkFKeySts
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.accAccountId = selection["accAccountId"];
       newState[newState.length - 1].paramsData.carCarrierId = selection["carCarrierId"];
       newState[newState.length - 1].paramsData.grpGroupId = selection["grpGroupId"];
       newState[newState.length - 1].paramsData.wrkFKeySts = selection["wrkFKeySts"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     //RCGRP031
     if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "grpGroup/rcgrp031SelGrpByAcct") ||
      (newFormData.nextScreen == "grpGroup/rcgrp031SelGrpByAcct" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
 
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const accAccountId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.accAccountId", newFormData)];
           const carCarrierId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.carCarrierId", newFormData)];
           const grpGroupId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.grpGroupId", newFormData)];
           const wrkFKeySts = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.wrkFKeySts", newFormData)];
           selection = {
             "accAccountId": accAccountId,
             "carCarrierId": carCarrierId,
             "grpGroupId": grpGroupId,
             "wrkFKeySts": wrkFKeySts
           }
         }
       }
 
       const jumpParams = AuthProxy.getJumpParams();
 
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.accAccountId = selection["accAccountId"];
       newState[newState.length - 1].paramsData.carCarrierId = selection["carCarrierId"];
       newState[newState.length - 1].paramsData.grpGroupId = selection["grpGroupId"];
       newState[newState.length - 1].paramsData.wrkFKeySts = selection["wrkFKeySts"];

       // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };
 
       console.log("newData : ", JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
       return;
     }
     // RCPID015
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "pidProductId/rcpid015SelLblNmAct") ||
    (newFormData.nextScreen == "pidProductId/rcpid015SelLblNmAct" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const pidProductIdDisplay = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.pidProductIdDisplay", newFormData)];
          const prdDescriptionAbbrev = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.prdDescriptionAbbrev", newFormData)];
          const ptyProductTypeCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ptyProductTypeCode", newFormData)];
          selection = {
           "pidProductIdDisplay": pidProductIdDisplay,
           "prdDescriptionAbbrev": prdDescriptionAbbrev,
           "ptyProductTypeCode": ptyProductTypeCode
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.pidProductIdDisplay = selection["pidProductIdDisplay"];
       newState[newState.length - 1].paramsData.prdDescriptionAbbrev = selection["prdDescriptionAbbrev"];
       newState[newState.length - 1].paramsData.ptyProductTypeCode = selection["ptyProductTypeCode"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return true;
    }
    //RCPID013
 if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "pidProductId/rcpid013ProdByGppcAct") ||
     (newFormData.nextScreen == "pidProductId/rcpid013ProdByGppcAct" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      if(newFormData.cmdKey == "12" &&
        AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiSelect == "Y") {
        const jumpParams = AuthProxy.getJumpParams();
        const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
        const rawMultiSelectData = currentState?.multiSelectData;
        const multiSelectData: any[] = Array.isArray(rawMultiSelectData)
          ? rawMultiSelectData
          : (rawMultiSelectData ? Object.values(rawMultiSelectData) : []);
        console.log("[RCPID013] multiselectdata count:", multiSelectData.length);
        const gpiIdNumber = newFormData.fields["ctl.gpiIdNumber"];
        const gpmGppcId = newFormData.fields["ctl.gpmGppcId"];
        const currentIndex = multiSelectData.findIndex((item: any) =>
          item.gpiIdNumber.trim() === gpiIdNumber.trim() &&
          item.gpmGppcId.trim() === gpmGppcId.trim()
        );
        const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiSelectData.length ? multiSelectData[currentIndex + 1] : null;
        if (nextRecord) {
          console.log("[RCPID013] navigating to next record:", nextRecord.gpiIdNumber, nextRecord.gpmGppcId);
          window.parent.postMessage({
            message: "navigate-to-program-internal",
            programCode: "RCPID013",
            parameters: [nextRecord.gpiIdNumber, nextRecord.gpmGppcId]
          }, '*');
          return;
        }
      }
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gpiIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiIdNumber", newFormData)];
          const gpmGppcId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpmGppcId", newFormData)];
          
          selection = {
           "gpiIdNumber": gpiIdNumber,
           "gpmGppcId": gpmGppcId,
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.gpiIdNumber = selection["gpiIdNumber"];
       newState[newState.length - 1].paramsData.gpmGppcId = selection["gpmGppcId"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    // RCPID017
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "pidProductId/rcpid017SelIdActive") ||
    (newFormData.nextScreen == "pidProductId/rcpid017SelIdActive" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const prdDescriptionAbbrev = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.prdDescriptionAbbrev", newFormData)];
          const pidProductIdDisplay = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.pidProductIdDisplay", newFormData)];
          const ptyProductTypeCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ptyProductTypeCode", newFormData)];
          selection = {
           "prdDescriptionAbbrev": prdDescriptionAbbrev,
           "pidProductIdDisplay": pidProductIdDisplay,
           "ptyProductTypeCode": ptyProductTypeCode
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.prdDescriptionAbbrev = selection["prdDescriptionAbbrev"];
       newState[newState.length - 1].paramsData.pidProductIdDisplay = selection["pidProductIdDisplay"];
       newState[newState.length - 1].paramsData.ptyProductTypeCode = selection["ptyProductTypeCode"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
//RCTRC003
 if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "trcTaxRateCodeTable/rctrc003EdtDspTrcMainPanel") ||
     (newFormData.nextScreen == "trcTaxRateCodeTable/rctrc003EdtDspTrcMainPanel" && newFormData.cmdKey == "12")) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const screenMode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.screenMode", newFormData)];
          const trcSeqNbr = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.trcSeqNbr", newFormData)];
          const trcState = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.trcState", newFormData)];
          const trcTaxRateCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.trcTaxRateCode", newFormData)];
          selection = {
           "screenMode": screenMode,
           "trcSeqNbr": trcSeqNbr,
           "trcState": trcState,
           "trcTaxRateCode": trcTaxRateCode,
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.screenMode = selection["screenMode"];
       newState[newState.length - 1].paramsData.trcSeqNbr = selection["trcSeqNbr"];
       newState[newState.length - 1].paramsData.trcState = selection["trcState"];
       newState[newState.length - 1].paramsData.trcTaxRateCode = selection["trcTaxRateCode"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
    // RCCTY004
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "ctyFipsCounty/rccty004SelByCode") ||
    (newFormData.nextScreen == "ctyFipsCounty/rccty004SelByCode" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const ctyCountyCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyCountyCode", newFormData)];
          const ctyCountyName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyCountyName", newFormData)];
          const ctyStateAbbreviation = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyStateAbbreviation", newFormData)];
          selection = {
           "ctyCountyCode": ctyCountyCode,
           "ctyCountyName": ctyCountyName,
           "ctyStateAbbreviation": ctyStateAbbreviation,
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.ctyCountyCode = selection["ctyCountyCode"];
      newState[newState.length - 1].paramsData.ctyCountyName = selection["ctyCountyName"];
      newState[newState.length - 1].paramsData.ctyStateAbbreviation = selection["ctyStateAbbreviation"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
 // RCSTD001I
       if(  newFormData.cmdKey == "12" && newFormData.nextScreen == "stdStateListDetail/rcstd001iStateListDtl") {
       const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
       let selection = {};
       for(const i in newFormData.subfile) {
         if(newFormData.subfile[i].recordSelected == "Y") {
           const stlStateListDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.stlStateListDesc", newFormData)];
           const stlStateListName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.stlStateListName", newFormData)];
           selection = {
            "stlStateListDesc": stlStateListDesc,
            "stlStateListName": stlStateListName,
           }
         }
       }
       const jumpParams = AuthProxy.getJumpParams();
       // Remove the last item from the state array
       const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.stlStateListDesc = selection["stlStateListDesc"];
       newState[newState.length - 1].paramsData.stlStateListName = selection["stlStateListName"];


      // Create a new object with the updated state
       const newData = {
         ...jumpParams.data,
         state: newState
       };

       console.log(JSON.stringify(newData));
       const message = {
         message: "navigate-to-external-program",
         url: backUrl,
         parameters: newData
       };
       window.parent.postMessage(message, "*");
     }
     // RCCTY003
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "ctyFipsCounty/rccty003CountyCodeDtlPanel") ||
    (newFormData.nextScreen == "ctyFipsCounty/rccty003CountyCodeDtlPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))||
    (newFormData.nextScreen == "ctyFipsCounty/rccty003CountyCodeDtlEntryPanel" && newFormData.cmdKey == "12"
      )) {
      if(newFormData.cmdKey == "12" && 
      AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiselect == "Y") {
      const jumpParams = AuthProxy.getJumpParams();
      const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
      const rawMultiSelectData = currentState?.multiselectdata;
      const multiSelectData: any[] = Array.isArray(rawMultiSelectData)
        ? rawMultiSelectData
        : (rawMultiSelectData ? Object.values(rawMultiSelectData) : []);
      console.log("[RCCTY003] multiselectdata count:", multiSelectData.length);
      const ctyCountyCode = newFormData.fields["key.ctyCountyCode"];
      const ctyCountyName = newFormData.fields["key.ctyCountyName"];
      const ctyStateAbbreviation = newFormData.fields["key.ctyStateAbbreviation"];
      const currentIndex = multiSelectData.findIndex((item: any) => item.ctyCountyCode == ctyCountyCode && item.ctyCountyName == ctyCountyName && item.ctyStateAbbreviation == ctyStateAbbreviation);
      const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiSelectData.length ? multiSelectData[currentIndex + 1] : null;
      if (nextRecord) {
        console.log("[RCCTY003] navigating to next record:", nextRecord.ctyCountyCode, nextRecord.ctyCountyName);
        window.parent.postMessage({
          message: "navigate-to-program-internal",
          programCode: "RCCTY003",
          parameters: [nextRecord.ctyStateAbbreviation, nextRecord.ctyCountyCode, nextRecord.ctyCountyName]
        }, '*');
        return;
      }
     }  
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const ctyCountyCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyCountyCode", newFormData)];
          const ctyCountyName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyCountyName", newFormData)];
          const ctyStateAbbreviation = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.ctyStateAbbreviation", newFormData)];
          selection = {
           "ctyCountyCode": ctyCountyCode,
           "ctyCountyName": ctyCountyName,
           "ctyStateAbbreviation": ctyStateAbbreviation,
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.ctyCountyCode = selection["ctyCountyCode"];
      newState[newState.length - 1].paramsData.ctyCountyName = selection["ctyCountyName"];
      newState[newState.length - 1].paramsData.ctyStateAbbreviation = selection["ctyStateAbbreviation"];
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
    // RCPIW007
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "piwProductIdWorkFile/rcpiw007ProdByNdcAct") ||
    (newFormData.nextScreen == "piwProductIdWorkFile/rcpiw007ProdByNdcAct" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      if(newFormData.cmdKey == "12" &&
      AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiSelect == "Y") {
      const jumpParams = AuthProxy.getJumpParams();
      const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
      const rawMultiSelectData = currentState?.multiSelectData;
      const multiSelectData: any[] = Array.isArray(rawMultiSelectData)
        ? rawMultiSelectData
        : (rawMultiSelectData ? Object.values(rawMultiSelectData) : []);
      console.log("[RCPIW007] multiselectdata count:", multiSelectData.length);
      const gpiName = newFormData.fields["ctl.gpiName"];
      const gpiNumber = newFormData.fields["ctl.gpiNumber"];
      const currentIndex = multiSelectData.findIndex((item: any) => item.gpiName.trim() == gpiName && item.gpiNumber == gpiNumber);
      const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiSelectData.length ? multiSelectData[currentIndex + 1] : null;
      if (nextRecord) {
        console.log("[RCPIW007] navigating to next record:", nextRecord.gpiName, nextRecord.gpiNumber);
        window.parent.postMessage({
          message: "navigate-to-program-internal",
          programCode: "RCPIW007",
          parameters: [nextRecord.gpiName, nextRecord.gpiNumber]
        }, '*');
        return;
      }
     }
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gpiName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiName", newFormData)];
           const gpiNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiNumber", newFormData)];
          selection = {
           "gpiName": gpiName,
           "gpiNumber": gpiNumber,
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.gpiName = selection["gpiName"];
       newState[newState.length - 1].paramsData.gpiNumber = selection["gpiNumber"];

     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
    // RCREJ001
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "rejRejectCodes/rcrej001SlctRejectCode") ||
    (newFormData.nextScreen == "rejRejectCodes/rcrej001SlctRejectCode" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const rejRejectCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rejRejectCode", newFormData)];
          const rejRejectCodeDesc = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.rejRejectCodeDesc", newFormData)];
          selection = {
           "rejRejectCode": rejRejectCode,
           "rejRejectCodeDesc": rejRejectCodeDesc          
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
       newState[newState.length - 1].paramsData.rejRejectCode = selection["rejRejectCode"];
       newState[newState.length - 1].paramsData.rejRejectCodeDesc = selection["rejRejectCodeDesc"];
     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
     // RCGPI900
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gpiMediSpanGpi/rcgpi900SelFullgpiName") ||
    (newFormData.nextScreen == "gpiMediSpanGpi/rcgpi900SelFullgpiName" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gpiIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiIdNumber", newFormData)];
          const gpiName = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiName", newFormData)];
          selection = {
            "gpiIdNumber": gpiIdNumber,
            "gpiName": gpiName
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.gpiIdNumber = selection["gpiIdNumber"];
      newState[newState.length - 1].paramsData.gpiName = selection["gpiName"];
     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
    // RCGPM900
      if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "gpmGppcMaster/rcgpm900SelectGppcActv") ||
    (newFormData.nextScreen == "gpmGppcMaster/rcgpm900SelectGppcActv" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const gpiIdNumber = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpiIdNumber", newFormData)];
          const gpmGppcId = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.gpmGppcId", newFormData)];
          selection = {
            "gpiIdNumber": gpiIdNumber,
            "gpmGppcId": gpmGppcId
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.gpiIdNumber = selection["gpiIdNumber"];
      newState[newState.length - 1].paramsData.gpmGppcId = selection["gpmGppcId"];
     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }

    //RCRAD003I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "radRouteOfAdmin/rcrad003iDspRouteAdminPanel") ||
    (newFormData.nextScreen == "radRouteOfAdmin/rcrad003iDspRouteAdminPanel" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const radRouteOfAdminCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.radRouteOfAdminCode", newFormData)];
          selection = {
            "radRouteOfAdminCode": radRouteOfAdminCode
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.radRouteOfAdminCode = selection["radRouteOfAdminCode"];
     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }

    //RCDF2001
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "df2DosageFormNarrative/rcdf2001DisplayDosNarr") ||
    (newFormData.nextScreen == "df2DosageFormNarrative/rcdf2001DisplayDosNarr" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const df1DosageFormCode = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.df1DosageFormCode", newFormData)];
          selection = {
            "df1DosageFormCode": df1DosageFormCode
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.df1DosageFormCode = selection["df1DosageFormCode"];
     // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }

    // RCCSS006
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "cssCostSourceAndType/rccss006SelCstSrcTypa") ||
    (newFormData.nextScreen == "cssCostSourceAndType/rccss006SelCstSrcTypa" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for(const i in newFormData.subfile) {
        if(newFormData.subfile[i].recordSelected == "Y") {
          const cssCostSource = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.cssCostSource", newFormData)];
          const cssCostType = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.cssCostType", newFormData)];
          const cssStatePricing = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.cssStatePricing", newFormData)];
          selection = {
            "cssCostSource": cssCostSource,
            "cssCostType": cssCostType,
            "cssStatePricing": cssStatePricing
          }
        }
      }

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.cssCostSource = selection["cssCostSource"];
      newState[newState.length - 1].paramsData.cssCostType = selection["cssCostType"];
      newState[newState.length - 1].paramsData.cssStatePricing = selection["cssStatePricing"];

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }

    // RCCSS001
    if ((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "cssCostSourceAndType/rccss001SelCstSrcTyp") ||
      (newFormData.nextScreen == "cssCostSourceAndType/rccss001SelCstSrcTyp" && newFormData.cmdKey == "12"
        && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1
        && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for (const i in newFormData.subfile) {
        if (newFormData.subfile[i].recordSelected == "Y") {
          const cssCostSource = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.cssCostSource", newFormData)];
          const cssCostType = newFormData.subfile[i].fields[this.getSubfileFieldIndex("rcd.cssCostType", newFormData)];
          selection = {
            "cssCostSource": cssCostSource,
            "cssCostType": cssCostType
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.cssCostSource = selection["cssCostSource"];
      newState[newState.length - 1].paramsData.cssCostType = selection["cssCostType"];
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }

    // RCMCC001
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "mccMacListCostHistory/rcmcc001MntmacCstsAct") ||
    (newFormData.nextScreen == "mccMacListCostHistory/rcmcc001MntmacCstsAct" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
        if(newFormData.cmdKey == "12" &&
          AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].multiselect == "Y") {
          const jumpParams = AuthProxy.getJumpParams();
          const currentState = jumpParams?.data?.state?.[jumpParams.data.state.length - 1];
          const rawmultiselectdata = currentState?.multiselectdata;
          const multiselectdata: any[] = Array.isArray(rawmultiselectdata)
            ? rawmultiselectdata
            : (rawmultiselectdata ? Object.values(rawmultiselectdata) : []);
          console.log("[RCMCC001] multiselectdata count:", multiselectdata.length);
          const carCarrierId = newFormData.fields["ctl.carCarrierId"];
          const macGenericName = newFormData.fields["ctl.macGenericName"];
          const macGpi = newFormData.fields["ctl.macGpi"];
          const macGppc = newFormData.fields["ctl.macGppc"];
          const macList = newFormData.fields["ctl.macList"];
          const macListName = newFormData.fields["ctl.macListName"];
          const macNdcLabelerId = newFormData.fields["ctl.macNdcLabelerId"];
          const macNdcPackageCode = newFormData.fields["ctl.macNdcPackageCode"];
          const macNdcProductCode = newFormData.fields["ctl.macNdcProductCode"];
          const wrkCarrierName = newFormData.fields["ctl.wrkCarrierName"];
          const currentIndex = multiselectdata.findIndex((item: any) =>
            item.carCarrierId.trim() === carCarrierId.trim() &&
            item.macGenericName.trim() === macGenericName.trim() &&
            item.macGpi.trim() === macGpi.trim() &&
            item.macGppc.trim() === macGppc.trim() &&
            item.macList.trim() === macList.trim() &&
            item.macListName.trim() === macListName.trim() &&
            item.macNdcLabelerId.trim() === macNdcLabelerId.trim() &&
            item.macNdcPackageCode.trim() === macNdcPackageCode.trim() &&
            item.macNdcProductCode.trim() === macNdcProductCode.trim()
          );
          const nextRecord = currentIndex >= 0 && currentIndex + 1 < multiselectdata.length ? multiselectdata[currentIndex + 1] : null;
          if (nextRecord) {
            console.log("[RCMCC001] navigating to next record:", nextRecord.carCarrierId, nextRecord.macList, nextRecord.macGpi);
            window.parent.postMessage({
              message: "navigate-to-program-internal",
              programCode: "RCMCC001",
              parameters: [
                nextRecord.carCarrierId,
                nextRecord.macGenericName,
                nextRecord.macGpi,
                nextRecord.macGppc,
                nextRecord.macList,
                nextRecord.macListName,
                nextRecord.macNdcLabelerId,
                nextRecord.macNdcPackageCode,
                nextRecord.macNdcProductCode,
                nextRecord.wrkCarrierName,
                nextRecord.modeFromPreviousScreen
              ]
            }, '*');
            return;
          }
        }
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
   // RCCSS005
    if ((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "cssCostSourceAndType/rccss005DspCstSrcTypPanel") ||
      (newFormData.nextScreen == "cssCostSourceAndType/rccss005DspCstSrcTypPanel" && newFormData.cmdKey == "12"
        && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1
        && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      let selection = {};
      for (const i in newFormData.subfile) {
        if (newFormData.subfile[i].recordSelected == "Y") {
          const cssCostSource = newFormData.fields["key.cssCostSource"];
          const cssCostType = newFormData.fields["key.cssCostType"];
          selection = {
            "cssCostSource": cssCostSource,
            "cssCostType": cssCostType
          }
        }
      }
      const jumpParams = AuthProxy.getJumpParams();
      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      newState[newState.length - 1].paramsData.cssCostSource = selection["cssCostSource"];
      newState[newState.length - 1].paramsData.cssCostType = selection["cssCostType"];
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
    // RCMCP001I
    if((newFormData.gridAction == 1 && newFormData.cmdKey == "00" && newFormData.nextScreen == "mcpMacListProducts/rcmcp001iAcmacProdbygpi") ||
    (newFormData.nextScreen == "mcpMacListProducts/rcmcp001iAcmacProdbygpi" && newFormData.cmdKey == "12"
      && AuthProxy.getJumpParams().data.state && AuthProxy.getJumpParams().data.state.length > 1 
      && newFormData.nextScreen.split("/")[1].startsWith(AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 2].legacyProgramCode.toLowerCase()))) {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;

      const jumpParams = AuthProxy.getJumpParams();

      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);

      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };

      console.log("newData : ", JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
      return;
    }
    // exisiting code
    if(newFormData.cmdKey == "12" && newFormData.nextScreen == "") {
      const backUrl = AuthProxy.getJumpParams().data.state[AuthProxy.getJumpParams().data.state.length - 1].previousScreen;
      const jumpParams = AuthProxy.getJumpParams();


      // Remove the last item from the state array
      const newState = jumpParams.data.state.slice(0, -1);
      // Create a new object with the updated state
      const newData = {
        ...jumpParams.data,
        state: newState
      };
      console.log(JSON.stringify(newData));
      const message = {
        message: "navigate-to-external-program",
        url: backUrl,
        parameters: newData
      };
      window.parent.postMessage(message, "*");
    }
  }

  /**
   * If applicable, add to metadata RRN assigned to the top row in the grid
   */
  addSubfileTopRRN(newFormData: any) {
    const replyFormData = newFormData;

    if (replyFormData && replyFormData['subfile'] && replyFormData['subfileHasAllData']) {
      if (replyFormData['subfile'].length > 0) {
        const topRRN = this.dataGrid.current.getTopRRN();

        if (topRRN) {
          replyFormData['subfileTopRRN'] = topRRN;
        }
      }
    }

    return replyFormData;
  }

  /**
   *
   */
  uselessFieldIsProtectedByProtectedCondition(input: any): boolean {
    let result = false;

    if (input.displayConditions) {
      input.displayConditions.forEach((c: any): void => {
        if (c.attributeValue && c.attribute === 'protect') {
          result = true;
        }
      });
    }

    return result;
  }

  /**
   * 
   * Get if the attribute is readonly
   */
  isReadOnly(input:any, formData:any): boolean {
    let readOnly = false;

    if(input?.initialDisplay) {
      for(const i in input.initialDisplay) {
        if(input.initialDisplay[i].attribute === "protect") {
          if(input.initialDisplay[i].attributeValue){
            readOnly = true;
          }
        }
      }
    }
    if(input.initialDisplay) {
      for(const i in input.displayConditions) {
        if(input.displayConditions[i].attribute === "protect") {
          if(this.formData.fieldConditions[input.field]) {
            readOnly = true;
          }
        }
      }
    }
 
    if(formData.DataprogramMode == "DSP") {
      readOnly = true;
    }
    return readOnly;
  }

  /**
   *
   */
  removeUselessDataFromPayload(newFormData: any): any {
    const replyFormData = newFormData;

    if (replyFormData) {
      // 1) Remove read-only Inputs (Initial display HIDDEN / PROTECT, displayCondition: HIDDEN / PROTECT)
      const uselessFields: any[] = [];
      // Get all useless fields
      if (this.screenDef.inputs) {
        this.screenDef.inputs.forEach((input: any) => {
          if (input.initialDisplay) {
            input.initialDisplay.forEach((c: any): void => {
              if (c.attributeValue && (c.attribute === 'protect' || c.attribute === 'hidden')) {
                if (this.uselessFieldIsProtectedByProtectedCondition(input) === false) {
                  uselessFields.push(input.field);
                }
              }
            });
          }
          if (input.displayConditions) {
            input.displayConditions.forEach((c: any): void => {
              if (c.attributeValue && (c.attribute === 'hidden') && this.isActiveCondition(replyFormData, c.conditionField)) {
                uselessFields.push(input.field);
              }
            });
          }
        });
      }

      if (uselessFields.length > 0 && replyFormData.fields) {
        uselessFields.forEach((field: any): void => {
          const idx = Object.keys(replyFormData.fields).indexOf(field);
          if (idx > -1) {
            delete replyFormData.fields[field];
          }
        });
      }

      // 2) Remove fieldConditions and functionKeyConditions
      if (replyFormData['fieldConditions']) {
        replyFormData['fieldConditions'] = {};
      }

      if (replyFormData['functionKeyConditions']) {
        replyFormData['functionKeyConditions'] = {};
      }

      // 3) Remove read-only subfile field (Initial display HIDDEN / PROTECT, displayCondition: HIDDEN / PROTECT)
      if (replyFormData['subfile']) {
        const uselessSubfileFields: any[] = [];
        // Get all useless fields
        if (this.screenDef.gridDefinition && this.screenDef.gridDefinition.columns) {
          this.screenDef.gridDefinition.columns.forEach((col: any) => {
            // We check for the first field in the column (a column can have multiple field in a cell)
            if (col[0].initialDisplay) {
              col[0].initialDisplay.forEach((c: any): void => {
                if (c.attributeValue && (c.attribute === 'protect' || c.attribute === 'hidden')) {
                  if (this.uselessFieldIsProtectedByProtectedCondition(col[0]) === false) {
                    uselessSubfileFields.push(col[0].field);
                  }
                }
              });
            }
            if (col[0].displayConditions) {
              col[0].displayConditions.forEach((c: any): void => {
                if (c.attributeValue && (c.attribute === 'hidden') && this.isActiveCondition(replyFormData['subfile'], c.conditionField)) {
                  uselessSubfileFields.push(col[0].field);
                }
              });
            }
          });
        }

        if (uselessSubfileFields.length > 0 && replyFormData.subfile) {
          uselessSubfileFields.forEach((field: any): void => {
            // for each row
            replyFormData.subfile.forEach((row: any) => {
              // for each field
              const idx = Object.keys(row.fields).indexOf(field);
              if (idx > -1) {
                delete row.fields[field];
              }
            });
          });
        }
      }
    }
    return replyFormData;
  }

  // ================================================================
  //  UI
  // ================================================================

  /**
   * Shows the loaders.
   */
  showLoader(): void {
    const loaderElement = document.getElementById('loaderModal');
    if (loaderElement) {
      loaderElement.classList.add('show');
    }
  }
   getTopButtons() {
    const topFunctions = [];
    for(const func in this.functionKeys) { 
      if(this.screenDef.gridDefinition && this.formData.subfile){
        if(this.functionKeys[func].label.includes("Back") || 
        this.functionKeys[func].label.includes("View") ||
        this.functionKeys[func].label == "Note" ||
        this.functionKeys[func].label.includes("Suppress Update") ||
        this.functionKeys[func].label.includes("Edit")) {
          topFunctions.push(this.functionKeys[func]);
        }
      }else{
        topFunctions.push(this.functionKeys[func]);
      }
    }
    return topFunctions;
  }

  getBottomButtons() {
    const bottomButtons = [];
    for(const func in this.functionKeys) { 
      if(this.functionKeys[func].label.includes("Back") || 
      this.functionKeys[func].label.includes("View") ||
      this.functionKeys[func].label == "Note" ||
      this.functionKeys[func].label.includes("Suppress Update") ||
      this.functionKeys[func].label.includes("Edit")) {
      } else {
        bottomButtons.push(this.functionKeys[func]);
      }
    }
    return bottomButtons;
  }

  /**
   *
   */
  render(): React.ReactElement {
    this.getTopButtons();
    if (this.screenDef.hasTopButtons == null) {
      this.screenDef.hasTopButtons = true;
    }

    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={50000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnHover={true}
        />
        {
          this.screenDef && (
            <div className="content-container clearfix">
              {/* <!-- TOOLBAR --> */}
                  {this.screenDef.hasTopButtons && 
                <div className="top-buttons">
                  <div id="toolbar" className={this.getToolbarClasses()}>
                    <div className="function-keys">
                      {this.functionKeys && (
                        <MegaMenu ref={(el: any): any => this.menu = el} model={this.getTopButtons()} />
                      )}
                    </div>
                  </div>
                </div>              
              }
              {this.screenDef.hasTopButtons && 
                <div id="toolbar" className={this.getToolbarClasses()}>
                  <div className="right-buttons" style={{display: this.screenDef.hasContinueButton === true ? '' : 'none'}}>
                    <FContinueButton
                      id="continue-button"
                      title="Save"
                      handleContinue={(): void => this.onSubmit()}
                      disabled={!this.props.isActiveScreen}
                    />
                  </div >
                </div>
              }
              
              {/* PROGRAM NAME */}
              <div className="container-fluid app-title-header">              
                {(this.formData.modalScreen && this.screenDef.snapshotScreen) ? 
                  <h1>{this.screenDef.title}</h1> :
                  <h1>{this.screenDef.isDynamicTitle ? this.generateDynamicTitle(this.formData.programMode, this.screenDef) : this.screenDef.title} - <span>{this.screenDef.isDynamicProgramName ? this.generateDynamicProgName(this.formData.programMode, this.screenDef) : this.screenDef.programName}</span></h1>
                }
              </div>
              {/* <!------- SNAPSHOT SCREENS -------> */}
              { this.formData.modalScreen  && this.screenDef.snapshotScreen && 
                  <SnapshotBase formData={this.formData} programName={this.screenDef.programName}></SnapshotBase> }
              {/* <!-- INPUTS (displayAtTheBottom is false, normal display) --> */}
              {this.formatedInputs && (
                <div className="container-fluid">
                  <form>
                    {this.formatedInputs.map((row: any, rowindex: any): any => (
                      <div className={`${this.screenDef.removeGrid ? 'row1' : 'row'}`} key={rowindex}>
                        {row.filter((obj: any): any => { return obj.pos.displayAtTheBottom === undefined; }).map((input: any, index: any): any => (
                          <React.Fragment key={index}>
                            {/* <!-- LABEL OBSOLETE (X2E3) --> */}
                            {input.isLabel && (
                              <div className={this.getItemClasses(input)}>
                                <FLabel
                                  id={input.field}
                                  name={input.field}
                                  text={input.label}
                                  size={input.size}
                                  color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                  readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                  highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                  protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                  reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                  underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                  hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                />
                              </div>
                            )}
                            {!input.isLabel && (
                              <div className={this.getItemClasses(input)}>
                                {/* <!-- NEW LABEL (XM3) --> */}
                                {input.type === 'label' && (
                                  <FLabel
                                    id={input.field}
                                    name={input.field}
                                    text={input.label}
                                    size={input.size}
                                    color={this.getCondition(this.conditions['labels'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['labels'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['labels'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['labels'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['labels'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['labels'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['labels'], input.field, 'hidden')}
                                  />
                                )}
                                {/* <!-- TEXT --> */}
                                {input.type === 'string' && (!this.isReadOnly(input, this.formData) ?
                                  <FTextInput
                                    id={input.field}
                                    name={input.field}
                                    size={input.size}
                                    placeholder={input.placeholder}
                                    value={this.formData['fields'][input.field]}
                                    label={input.labelLocation === 'above' ? input.header1 : input.label}
                                    maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                    required={input.required}
                                    error={this.inputErrors[input.field]}
                                    displayFormat={input.displayFormat}
                                    onValueChange={(newValue: any): void => {
                                      const formData = this.formData;
                                      formData['fields'][input.field] = input.displayFormat && input.displayFormat.textCase && input.displayFormat.textCase === 'uppercase' ? newValue.toUpperCase() : newValue;
                                      this.forceUpdate();
                                    }}
                                    promptable={input.lookupFlag}
                                    onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                    suffix={input.options ? input.options.suffix : null}
                                    labelOnTop={input.labelLocation === 'above'}
                                    onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                    onBlur={(): void => { }}
                                    color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                    alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                  />  : <TextDisplay input={input} formData={this.formData}></TextDisplay>
                                )}
                                {/* <!-- MULTILINE --> */}
                                {input.type === 'multiline' && (!this.isReadOnly(input, this.formData) ?
                                  <FMultilineInput
                                    id={input.field}
                                    name={input.field}
                                    size={input.size}
                                    value={this.formData['fields'][input.field]}
                                    label={input.labelLocation === 'above' ? input.header1 : input.label}
                                    maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                    required={input.required}
                                    error={this.inputErrors[input.field]}
                                    displayFormat={input.displayFormat}
                                    onValueChange={(newValue: any): void => {
                                      const formData = this.formData;
                                      formData['fields'][input.field] = input.displayFormat && input.displayFormat.textCase && input.displayFormat.textCase === 'uppercase' ? newValue.toUpperCase() : newValue;
                                      this.forceUpdate();
                                    }}
                                    promptable={input.lookupFlag}
                                    onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                    suffix={input.options ? input.options.suffix : null}
                                    labelOnTop={input.labelLocation === 'above'}
                                    onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                    onBlur={(): void => { }}
                                    color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                    alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                  /> : <TextDisplay input={input} formData={this.formData}></TextDisplay>
                                )}
                                {/* <!-- NUMERIC --> */}
                                {input.type === 'number' && (!this.isReadOnly(input, this.formData) ?
                                  < FNumericInput
                                    id={input.field}
                                    name={input.field}
                                    placeholder={input.placeholder}
                                    size={input.size}
                                    value={this.formData['fields'][input.field]}
                                    label={input.labelLocation === 'above' ? input.header1 : input.label}
                                    maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                    required={input.required}
                                    error={this.inputErrors[input.field]}
                                    displayFormat={input.displayFormat}
                                    onValueChange={(newValue: any): void => {
                                      const formData = this.formData;
                                      formData['fields'][input.field] = newValue;
                                      this.forceUpdate();
                                    }}
                                    promptable={input.lookupFlag}
                                    onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                    suffix={input.options ? input.options.suffix : null}
                                    labelOnTop={input.labelLocation === 'above'}
                                    onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                    onBlur={(): void => { }}
                                    color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                    alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                  />  : <TextDisplay input={input} formData={this.formData}></TextDisplay>
                                )}
                                {/* <!-- DATE & TIME --> */}
                                {(input.type === 'datetime' || input.type === 'date' || input.type === 'time') && (!this.isReadOnly(input, this.formData) ?
                                  <FDateTimeInput
                                    id={input.field}
                                    type={input.type}
                                    size={input.size}
                                    dateFormat={this.dateFormat}
                                    timeSeparator={this.timeSeparator}
                                    showSeconds={this.showSeconds}
                                    name={input.field}
                                    value={this.formData['fields'][input.field]}
                                    label={input.labelLocation === 'above' ? input.header1 : input.label}
                                    maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                    required={input.required}
                                    error={this.inputErrors[input.field]}
                                    displayFormat={input.displayFormat}
                                    onValueChange={(newValue: any): void => {
                                      const formData = this.formData;
                                      formData['fields'][input.field] = input.displayFormat && input.displayFormat.textCase && input.displayFormat.textCase === 'uppercase' ? newValue.toUpperCase() : newValue;
                                      this.forceUpdate();
                                    }}
                                    promptable={input.lookupFlag}
                                    onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                    suffix={input.options ? input.options.suffix : null}
                                    labelOnTop={input.labelLocation === 'above'}
                                    onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                    onBlur={(): void => { }}
                                    color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                    alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                  />
                                  : <TextDisplay input={input} formData={this.formData}></TextDisplay>
                                )}
                                {input.type === "search-dropdown" && (!this.isReadOnly(input, this.formData) ?
                                    <FSelectInput
                                      id={input.field}
                                      customValue={input.customValue}
                                      name={input.field}
                                      size={input.size}
                                      values={this.getDropdownValues(input.options, input.field)}
                                      value={this.formData['fields'][input.field]}
                                      label={input.labelLocation === 'above' ? input.header1 : input.label}
                                      maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                      required={input.required}
                                      error={this.inputErrors[input.field]}
                                      displayFormat={input.displayFormat}
                                      onValueChange={(newValue: any): void => {
                                        const formData = this.formData;
                                        formData['fields'][input.field] = input.displayFormat && input.displayFormat.textCase && input.displayFormat.textCase === 'uppercase' ? newValue.toUpperCase() : newValue;
                                        for (let i = 0; i < formData['subfile'].length; i++) {
                                          formData['subfile'][i]['recordDataChanged'] = 'N';
                                        }
                                        formData['cmdKey'] = "00";
                                        this.forceUpdate();
                                        this.showLoader();
                                        this.replyToBackend(formData);
                                      }}
                                      autofocus={this.formData['cursorField'] === input.field}
                                      promptable={input.lookupFlag}
                                      onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                      suffix={input.options ? input.options.suffix : null}
                                      labelOnTop={input.labelLocation === 'above'}
                                      onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                      onBlur={(): void => { }}
                                      color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                      readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                      highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                      protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                      reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                      underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                      hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                      alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                    />
                                    : <TextDisplay input={input} formData={this.formData} dropdownValue={this.getDropdownValues(input.options, input.field)}></TextDisplay>
                                  )
                                  }
                                {/* <!-- SELECT --> */}
                                {input.type === 'dropdown' && (!this.isReadOnly(input, this.formData) ?
                                  <FSelectInput
                                    id={input.field}
                                    name={input.field}
                                    size={input.size}
                                    values={this.getDropdownValues(input.options, input.field)}
                                    value={this.formData['fields'][input.field]}
                                    label={input.labelLocation === 'above' ? input.header1 : input.label}
                                    maxlength={input.displayFormat && input.displayFormat.textLength ? input.displayFormat.textLength : input.textLength}
                                    required={input.required}
                                    error={this.inputErrors[input.field]}
                                    displayFormat={input.displayFormat}
                                    onValueChange={(newValue: any): void => {
                                      const formData = this.formData;
                                      formData['fields'][input.field] = input.displayFormat && input.displayFormat.textCase && input.displayFormat.textCase === 'uppercase' ? newValue.toUpperCase() : newValue;
                                      this.forceUpdate();
                                    }}
                                    promptable={input.lookupFlag}
                                    customValue={input.customValue}
                                    onPrompt={input.lookupFlag ? (): void => this.promptAction(input.field, input.fieldId) : null}
                                    suffix={input.options ? input.options.suffix : null}
                                    labelOnTop={input.labelLocation === 'above'}
                                    onFocus={(): void => this.onFieldFocus(input.field, input.fieldId)}
                                    onBlur={(): void => { }}
                                    color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                    readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                    highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                    protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                    reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                    underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                    hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                    alwaysVisibleLabel={this.alwaysVisibleLabel(input.field)}
                                  />
                                  : <TextDisplay input={input} formData={this.formData} dropdownValue={this.getDropdownValues(input.options, input.field)}></TextDisplay>
                                )}
                                {['string', 'label', 'multiline', 'number', 'datetime', 'date', 'time', 'dropdown'].includes(input.type) === false && (
                                  this.renderCustomComponent(input)
                                )}
                              </div>
                            )}
                            {input.rightLabel && (
                              <div className={this.getRightLabelClass(input)}>
                                <FLabel
                                  id={input.field}
                                  name={input.field}
                                  size={input.size}
                                  text={input.rightLabel}
                                  color={this.getCondition(this.conditions['inputs'], input.field, 'color')}
                                  readonly={this.getCondition(this.conditions['inputs'], input.field, 'readonly')}
                                  highintensity={this.getCondition(this.conditions['inputs'], input.field, 'highintensity')}
                                  protect={this.getCondition(this.conditions['inputs'], input.field, 'protect')}
                                  reverseimage={this.getCondition(this.conditions['inputs'], input.field, 'reverseimage')}
                                  underline={this.getCondition(this.conditions['inputs'], input.field, 'underline')}
                                  hidden={this.getCondition(this.conditions['inputs'], input.field, 'hidden')}
                                />
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    ))
                    }
                  </form>
                </div>
              )}               
              {/* <!-- GRID --> */}
              {(this.screenDef.gridDefinition && this.formData.subfile) && (
                <div>
                  <div className="row">
                    <div id="toolbar" className={this.getToolbarClasses()}>
                      <div className="function-keys">
                        {this.functionKeys && (
                          <MegaMenu ref={(el: any): any => this.menu = el} model={this.getBottomButtons()} />
                        )}
                      </div>

                      {this.screenDef.showReport && (
                        <div className="top-buttons">
                          <div className="right-buttons">
                            <Tooltip target=".custom-tooltip-functionkey" position="top" />
                            <button className="export-button custom-tooltip-functionkey" data-pr-tooltip={`Generates Report having Products for the current GPI`} onClick={(): void => this.onGridSearchSubmit()}>Report</button>
                          </div>
                        </div>
                      )}
                      
                      <div className="export">
                        <div className="right-buttons">        
                          <button className="export-button" onClick={(): void => this.onGridSearchSubmit()}>Export as CSV</button>      
                          <div className="right-buttons" style={{display: this.screenDef.lowerContinueButton === true ? '' : 'none'}}>
                            <FContinueButton
                              id="continue-button"
                              title="Save"
                              handleContinue={(): void => this.onSubmit()}
                              disabled={!this.props.isActiveScreen}
                            />
                          </div >      
                        </div>
                      </div>                     
                    </div>
                  </div>

                  <div className="container-fluid" ref={(el: any): any => this.keysNavigation = el}>
                    {this.showGrid() && (
                      <OptumGrid
                        ref={(el: any): any => this.dataGrid = el}
                        model={this.formData}
                        screenDef={this.screenDef}
                        filterErrors={this.inputErrors}
                        onModelChange={(newModel: any): any => { this.formData = newModel; this.forceUpdate(); }}
                        onPageChange={(event: any): void => this.pageChanged(event)}
                        conditions={this.conditions}
                        onActionButton={this.tableAction}
                        actionsAsMenu={window.config['ui']['actionButtonMenu']}
                        actionMenuIcon={window.config['ui']['actionMenuIcon']}
                        actionMenuPos={window.config['ui']['actionMenuPos']}
                        dateFormat={this.dateFormat}
                        timeSeparator={this.timeSeparator}
                        showSeconds={this.showSeconds}
                        onTableFieldFocus={(fieldName: string, shortFieldName: string, rowIndex: number): void => this.onTableFieldFocus(fieldName, shortFieldName, rowIndex)}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          )
        }
      </React.Fragment >
    );
  }
}

export default BaseComponent;